import {I18N_EN, normalizeI18nLanguage} from '@constants/languages';
import i18next from 'i18next';
import {initReactI18next} from 'react-i18next';

const savedLanguage = normalizeI18nLanguage(
  localStorage.getItem('language') || I18N_EN,
);

i18next.use(initReactI18next).init({
  resources: {
    'en-US': {
      translation: {
        layout: {
          storeNameNotSetup: 'Store name not set up',
          setupNow: 'Set up now',
          addProduct: 'Add Product',
          saveChanges: 'Save Changes',
          cancel: 'Cancel',
          removeProduct: 'Remove Product',
          addMoneySpent: 'Add Money Spent',
          remove: 'Remove',
        },
        dashboard: {
          user: 'User',
          confirmation: 'CONFIRMATION',
          discount: 'DISCOUNT',
          receivedFor: 'RECEIVED FOR',
          status: 'STATUS',
          pending: 'PENDING',
          purchased: 'PURCHASED',
          level: 'LEVEL',
          points: 'POINTS',
          spent: '$ SPENT',
          noData: 'No data found',
          showPrevious: 'Show previous 10 results',
          showNext: 'Show next 10 results',
          giftsRedeemed: 'Gifts Redeemed',
          pointsRedeemed: 'Points Redeemed',
          newRequests: 'New Requests',
          newUsers: 'New Users',
          newPurchases: 'New Purchases',
          loading: 'Loading...',
          latestRequests: 'Latest Requests',
          accept: 'Accept',
          reject: 'Reject',
          productPurchase: 'Product Purchase',
          rewardClaim: 'Reward Claim',
          giftClaim: 'Gift Claim',
        },
        sidebar: {
          menuItems: {
            home: 'Home',
            inventory: 'Inventory',
            shopUsers: 'Shop Users',
            approveRedeems: 'Approve Redeems',
            pointsSetup: 'Points Setup',
            storeSetup: 'Store Setup',
            analytics: 'Analytics',
            marketing: 'Marketing',
          },
          menu: 'Main Menu',
          store: 'Store',
          logout: 'Log Out',
        },
        storeSetup: {
          dashboard: 'Dashboard',
          loyaltyProgramStoreSetup: 'Loyalty Program Store Setup',
          storeName: 'Store Name',
          enterStoreName: 'Enter Store Name',
          storeNameNotSetup: 'Store name not set up',
          setupNow: 'Set up now',
          storeQRCode: 'Store QR Code',
          generate: 'Generate',
          uploadLogo: 'Upload Logo',
          storeLogo: 'Store Logo',
          downloadImage: 'Download Image',
          storeUpdated: 'Store updated',
          updateError: 'Error updating store',
          updateErrorEs: 'Error al actualizar la tienda',
          maxLengthExceeded:
            'Maximum length of {{maxLength}} characters exceeded',
          maxLengthExceededEs:
            'Se excedió la longitud máxima de {{maxLength}} caracteres',
          characters: 'characters',
          charactersEs: 'caracteres',
          imageSizeError: 'Image size should be less than 5 MB',
          invalidFileType: 'Only JPG, PNG and SVG images are allowed',
          invalidFileTypeEs: 'Solo se permiten imágenes JPG, PNG y SVG',
          downloadError: 'Error downloading QR code',
          downloadErrorEs: 'Error al descargar el código QR',
          processingFile: 'Processing file...',
          updatingStore: 'Updating store...',
          processing: 'Processing...',
          saving: 'Saving...',
          uploadLogoDescription: 'Upload a store logo image (JPG, PNG, or SVG)',
        },
        pointsSetup: {
          dashboard: 'Dashboard',
          loyaltyProgramSetup: 'Loyalty Program Setup',
          bronze: 'Bronze',
          silver: 'Silver',
          gold: 'Gold',
          awardsForLevel: 'Awards for Level',
          discount: 'Discount',
          gift: 'Gift',
          changeGift: 'Change Gift',
          noGift: 'No Gift',
          awardsManagement: 'Awards Management',
          status: 'STATUS',
          discount2: 'DISCOUNT',
          points: 'POINTS',
          gift2: 'GIFT',
          action: 'ACTION',
          addReward: 'ADD REWARD',
          addRewardTitle: 'ADD REWARD',
          awardType: 'AWARD TYPE',
          awardTypeEnglish: 'Award Type (English)',
          awardTypeSpanish: 'Award Type (Spanish)',
          level: 'LEVEL',
          selectLevel: 'SELECT LEVEL',
          enabled: 'ENABLED',
          save: 'Save',
          loading: 'Loading...',
          newAwardCreated: 'New award created',
          remove: 'Remove',
          selectGift: 'Select Gift',
          noRewards: 'No rewards found for this level',
          selectValidLevel: 'Please select a valid level',
          awardTypeRequired: 'Award type is required',
          duplicateAward:
            'An award with this name already exists for this level',
          networkError: 'Network error, please check your connection',
          unauthorized: 'Authentication required',
          forbidden: 'You do not have permission to perform this action',
          serverError:
            'Server error. This could be due to a duplicate award name.',
          errorCreatingAward: 'Error creating award',
          loadingError: 'Error loading data',
          statusUpdated: 'Award status updated',
          updateError: 'Failed to update award',
          fetchError: 'Failed to fetch rewards data',
          loadingLevelsError: 'Error loading levels',
          discountValidNumber: 'Discount must be a valid number',
          discountNegative: 'Discount cannot be negative',
          discountExceedsMax: 'Discount cannot exceed 100%',
          pointsValidNumber: 'Points must be a valid number',
          pointsNegative: 'Points cannot be negative',
          pointsWholeNumber: 'Points must be a whole number',
          awardTypeEmpty: 'Award type cannot be empty',
          errorLoadingLevels: 'Error loading levels',
          genericError: 'An unexpected error occurred',
          serverResponseError: 'Server returned an error',
          unknownLevel: 'Unknown Level',
          noAwardType: 'No award type available',
        },
        approve: {
          title: 'Automate Approvals',
          rewards: 'Rewards',
          gifts: 'Gifts',
          purchase: 'Purchases',
          acceptSelected: 'Approve Selected',
          rejectSelected: 'Reject Selected',
          noData: 'No data found',
          showPrevious: 'Show previous 10 results',
          showNext: 'Show next 10 results',
          received: 'Received',
          points: 'Points',
          user: 'User',
          detail: 'Detail',
          date: 'Date',
          status: 'Status',
          level: 'Level',
          confirmation: 'Confirmation',
          paid: 'Paid',
          purchased: 'Purchased',
          accept: 'Accept',
          reject: 'Reject',
          // New translation keys added for bulk selection functionality
          noItemsSelected:
            'Please select at least one item to approve/reject',
          selectedItemsApproved:
            'Selected items approved successfully',
          selectedItemsRejected:
            'Selected items rejected successfully',
          errorApprovingItems:
            'Error approving selected items. Please try again.',
          errorRejectingItems:
            'Error rejecting selected items. Please try again.',
          itemsSelected: 'item(s) selected',
          insufficientPoints:
            'User does not have enough points for this purchase',
          bulkPurchasesApproved: '{{count}} purchase(s) approved successfully',
          bulkPurchasesRejected: '{{count}} purchase(s) rejected successfully',
          bulkPurchasesSkipped:
            '{{count}} purchase(s) were already in that status',
          bulkPurchasesFailed: '{{count}} purchase(s) could not be updated',
          bulkPurchasesNoChanges: 'No purchases were updated',
          searchCustomer: 'Search by customer name or email',
          clearSearch: 'Clear search',
        },
        shopUsers: {
          dashboard: 'Dashboard',
          users: 'Users',
          user: 'User',
          pending: 'Pending',
          purchases: 'Purchases',
          level: 'Level',
          points: 'Points',
          spent: 'Spent',
          activeStatus: 'Active Status',
          noData: 'No data found',
          showPrevious: 'Show previous 10 results',
          showNext: 'Show next 10 results',
        },
        products: {
          dashboard: 'Dashboard',
          products: 'Products',
          searchProduct: 'Search by product name',
          noData: 'No data found',
          product: 'Product',
          status: 'Status',
          cost: 'Cost',
          purchased: 'Purchased',
          available: 'Available',
          action: 'Action',
          addProduct: 'Add product',
          name: 'Name',
          nameEnglish: 'Name (English)',
          nameSpanish: 'Name (Spanish)',
          pointCost: 'Points cost',
          availableStock: 'Available stock',
          addProductImage: 'Add product image',
          enabled: 'Enabled',
          isGift: 'Is gift',
          save: 'Save',
          productAdded: 'Product added',
          remove: 'Remove',
          showPrevious: 'Show previous 10 results',
          showNext: 'Show next 10 results',
          bothNamesRequired: 'Both names are required',
          description: 'Description',
          descriptionEnglish: 'Description (English)',
          descriptionSpanish: 'Description (Spanish)',
          maxCharacters: 'max {{count}} characters',
          charactersCount: '{{current}}/{{max}} characters',
        },
        Productdetails: {
          dashboard: 'Dashboard',
          products: 'Products',
          addImage: 'Add image',
          name: 'Name',
          nameEnglish: 'Name (English)',
          nameSpanish: 'Name (Spanish)',
          pointCost: 'Points cost',
          availableStock: 'Available stock',
          enabled: 'Enabled',
          isGift: 'Is gift',
          save: 'Save',
          productAdded: 'Product added',
          remove: 'Remove',
          showPrevious: 'Show previous 10 results',
          showNext: 'Show next 10 results',
          description: 'Description',
          descriptionEnglish: 'Description (English)',
          descriptionSpanish: 'Description (Spanish)',
          noReviews: 'No reviews found',
          review: 'Review',
          reviews: 'Reviews',
          noComments: 'No comments',
          comments: 'Comments',
          anonymous: 'Anonymous',
          productReviews: 'Product reviews',
          user: 'User',
          score: 'Score',
          date: 'Date',
          comment: 'Comment',
          action: 'Action',
          maxCharacters: 'max {{count}} characters',
          charactersCount: '{{current}}/{{max}} characters',
          updateError: 'Error updating product',
          imageUploadSuccess: 'Image uploaded successfully',
          imageUploadError: 'Error uploading image',
          deleteError: 'Error deleting product',
          loadError: 'Error loading product information',
          validationError:
            'Please fill in all required fields with valid values',
          deleteConfirm: 'Are you sure you want to delete this product?',
          reviewDeleted: 'Review deleted successfully',
          reviewDeleteError: 'Error deleting review',
          deleteImage: 'Delete Image',
          deleteImageConfirm: 'Are you sure you want to delete this image?',
          imageDeleted: 'Image deleted successfully',
          imageDeleteError: 'Error deleting image',
        },
        common: {
          english: 'English',
          spanish: 'Spanish',
          loading: 'Loading...',
          save: 'Save',
          cancel: 'Cancel',
          delete: 'Delete',
          edit: 'Edit',
          search: 'Search',
          filter: 'Filter',
          actions: 'Actions',
          yes: 'Yes',
          no: 'No',
          success: 'Success',
          error: 'Error',
          warning: 'Warning',
          info: 'Info',
          invalidFileType: 'Only JPG, PNG and SVG images are allowed',
          invalidFileTypeEs: 'Solo se permiten imágenes JPG, PNG y SVG',
          fileSizeError: 'File size should be less than 5 MB',
          fileSizeErrorEs: 'El tamaño del archivo debe ser menor a 5 MB',
          fileProcessingError: 'Error processing file',
          fileProcessingErrorEs: 'Error al procesar el archivo',
        },
        auth: {
          login: 'Login',
          logout: 'Log Out',
          email: 'Email',
          password: 'Password',
          forgotPassword: 'Forgot Password?',
          rememberMe: 'Remember Me',
          signIn: 'Sign In',
          signUp: 'Sign Up',
          welcome: 'Welcome',
          loginToAccount: 'Login to your account',
          createAccount: 'Create a new account',
          dontHaveAccount: "Don't have an account?",
          alreadyHaveAccount: 'Already have an account?',
          signUpNow: 'Sign up now',
          signInNow: 'Sign in now',
          firstName: 'First Name',
          lastName: 'Last Name',
          enterFirstName: 'Enter First Name',
          enterLastName: 'Enter Last Name',
          enterEmail: 'Enter Email',
          enterPassword: 'Enter Password',
          confirmPassword: 'Confirm Password',
          newPassword: 'New Password',
          enterNewPassword: 'Enter New Password',
          resetMyPassword: 'Reset My Password',
          setupNewPassword: 'Setup a new password',
          termsAndConditions: 'Terms and conditions',
          agreeToTerms: 'By signing up you agree to the Next Level Technology',
          checkEmail: 'Check your mail!',
          resetLinkSent:
            'A password reset link has been sent to your email, kindly check your mailbox to proceed.',
          resetPasswordTitle: 'Forgot my password',
          resetPasswordDesc:
            'Enter the email you used to register and we will send you a password reset link.',
          loginError: 'Login Error',
          registerError: 'Register Error',
          resetError: 'Failed to reset password',
          resetPasswordError: 'Failed to reset password',
          passwordResetSuccess: 'Password has been reset successfully',
          invalidResetLink:
            'Invalid password reset link. Please request a new one.',
          tokenError: 'Failed to send token',
          passwordMatch: 'Password does not match',
          enterEmailAddress: 'Please enter email address',
          resetLinkSuccess: 'A reset link has been sent to your email address',
          resetPassword: 'Reset My Password',
          termsTitle:
            'NEXT LEVEL TECHNOLOGY, US CORPORATION SOFTWARE AND SERVICES TERMS OF USE',
          termsContent:
            'BY ACCEPTING THESE TERMS, BY (1) CLICKING A BOX OR BUTTON INDICATING ACCEPTANCE, (2) EXECUTING AN ORDER FORM THAT REFERENCES THESE TERMS, OR (3) USING A FREE PRODUCT, YOU AGREE TO THESE TERMS. IF YOU REGISTER FOR NEXT LEVEL Technology, US\' FREE PRODUCT, THE APPLICABLE PROVISIONS OF THESE TERMS WILL ALSO GOVERN THAT FREE PRODUCT. IF THE INDIVIDUAL ACCEPTING THESE TERMS IS ACCEPTING ON BEHALF OF A COMPANY OR OTHER LEGAL ENTITY, SUCH INDIVIDUAL REPRESENTS THAT THEY HAVE THE AUTHORITY TO BIND SUCH ENTITY AND ITS AFFILIATES TO THESE TERMS, IN WHICH CASE THE TERM "YOU" REFERS TO SUCH ENTITY AND ITS AFFILIATES. IF THE INDIVIDUAL ACCEPTING THESE TERMS DOES NOT HAVE SUCH AUTHORITY, OR DOES NOT AGREE WITH THESE TERMS, SUCH INDIVIDUAL MUST NOT ACCEPT THESE TERMS AND MAY NOT USE THE PLATFORM.',
          termsPlatform: '1. Platform.',
          termsPlatformContent:
            'Subject to the terms and conditions of these Terms, Next Level Technology, US grants you during the Term (defined below) a limited, non-exclusive, non-transferable, non-sublicenseable right to access and use the Next Level Technology, US website, software development platform, engineering workforce and module library (collectively, the',
          termsPlatformContent2:
            '"Platform") for the purpose of managing, hosting, developing, launching, andanalyzing your proprietary software applications (',
          termsPlatformContent3: '"Apps"',
          termsServices: '2. Professional Services.',
          termsServicesContent:
            'Subject to the terms and conditions of these Terms, Next Level Technology, US will perform the professional engineering, design, or product management Services set forth on an Order Form or as otherwise requested through the Platform, which may include managed use of the Platform by Next Level Technology, US on your behalf',
          termsServicesContent2: '"Services")',
          termsServicesContent3:
            ". The manner and means by which Next Level Technology, US chooses to complete the Services are in Next Level Technology, US' sole discretion and control. Next Level Technology, US' obligations to provide the Services are conditioned upon receiving such information and cooperation from you as may be reasonably necessary to perform the Services.",
          termsRestrictions: '3. Restrictions.',
          termsRestrictionsContent:
            'The rights granted to you in these Terms are subject to the following restrictions: (a) you may not license, sell, rent, lease, transfer, assign, distribute, host, or otherwise commercially exploit the Platform, whether in whole or in part, or any content displayed on the Platform; (b) you may not modify, make derivative works of, disassemble, reverse compile or reverse engineer any part of the Platform; and (c) except as expressly stated herein, no part of the Platform may be copied, reproduced, distributed, republished, downloaded, displayed, posted or transmitted in any form or by any means. Unless otherwise indicated, any future release, update, or other addition to functionality of the Platform is subject to these Terms. Unless otherwise specified on the Platform, all copyright and other proprietary notices on the Platform (or on any content displayed on the Platform) must be retained on all copies thereof.',
          termsResponsibilities: '4. Your Responsibilities.',
          termsResponsibilitiesContent:
            "You will (a) be responsible for your authorized users' (",
          termsResponsibilitiesContent2: '"Users")',
          termsResponsibilitiesContent3:
            "compliance with these Terms and Order Forms, (b) be responsible for the accuracy, quality and legality of User Content (defined below), (c) be responsible for your use of your Apps (including any Invention and any Prior Invention or Reusable Module (each defined below) incorporated into an Invention) and the interoperation of your App with any third party application, (d) use commercially reasonable efforts to prevent unauthorized access to or use of Platform, and notify Next Level Technology, US promptly of any such unauthorized access or use, and (e) use the Platform and Services only in accordance with these Terms and applicable laws and government regulations. Any use of the Platform in breach of the foregoing by you or Users that in Next Level Technology, US' judgment threatens the security, integrity or availability of Next Level Technology' Services, may result in Next Level Technology, US' immediate suspension of the Platform, however Next Level Technology, US will use commercially reasonable efforts under the circumstances to provide you with notice and an opportunity to remedy such violation or threat prior to any such suspension.",
          termsAccount: '5. Accounts.',
          termsRegister: 'a. Registration.',
          termsRegisterContent:
            'In order to use certain features of the Platform, you must register for an account ("Account") and provide certain information about yourself as prompted by the account registration form. You represent and warrant that: (i) all required registration information you submit is truthful and accurate; (ii) you will maintain the accuracy of such information. You may delete your Account at any time, for any reason, by following the instructions on the Platform. Next Level Technology, US may suspend or terminate your Account in accordance with Section 9.',
          termsAccountResponsibilities: 'b. Responsibilities.',
          termsAccountResponsibilitiesContent:
            'You are responsible for maintaining the confidentiality of your Account login information and are fully responsible for all activities that occur under your Account. You agree to immediately notify Next Level Technology, US of any unauthorized use, or suspected unauthorized use of your Account or any other breach of security. Next Level Technology, US cannot and will not be liable for any loss or damage arising from your failure to comply with the above requirements.',
          termsOwnership: '6. Ownership.',
          termsOwnershipPlatform: 'a. Platform.',
          termsOwnershipPlatformContent:
            'Next Level Technology, US retains all rights in the Platform, except as expressly set forth in these Terms.',
          termsOwnershipApps: 'b. Apps.',
          termsOwnershipAppsContent:
            'You own your Apps, subject to the terms and conditions of these Terms.',
          termsOwnershipInvention: 'c. Inventions.',
          termsOwnershipInventionContent:
            'All rights in and to any copyrightable software, algorithm, code, material, notes, records, drawings, designs, inventions, improvements, developments, discoveries and trade secrets (',
          termsOwnershipInventionContent2: '"Materials")',
          termsOwnershipInventionContent3:
            'conceived, discovered, authored, invented, developed or reduced to practice by Next Level Technology, US, solely or in collaboration with others, during the Term and arising out of, or in connection with, performing the Services under these Terms and any copyrights, patents, trade secrets, mask work rights or other intellectual property rights relating to the foregoing (collectively, but excluding Prior Inventions and Reusable Modules',
          termsOwnershipInventionContent4: '"Inventions")',
          termsOwnershipInventionContent5:
            '), are your sole property. Next Level Technology, US will promptly disclose any Invention to you in writing and will deliver and assign (or cause to be assigned) and hereby assigns fully to you all right, title and interest in and to the Inventions. Next Level Technology, US will reasonably assist you to further evidence, record and perfect such assignments, and to perfect, obtain, maintain, enforce and defend any rights assigned. Notwithstanding the foregoing, Next Level Technology, US reserves the right to use and re-use any generalized knowledge it gains arising from the performance of Services in its business without liability to you.',
          termsOwnershipInventionContent6: 'd. Prior Inventions.',
          termsOwnershipInventionContent7:
            'If, in the course of performing Services, Next Level Technology, US incorporates into any Invention or uses any pre-existing Materials owned by Next Level Technology, US or in which Next Level Technology, US has an interest (',
          termsOwnershipInventionContent8: '"Prior Inventions")',
          termsOwnershipInventionContent9:
            '), then Next Level Technology, US grants you a non-exclusive, royalty-free, perpetual, irrevocable, transferable, worldwide, sublicenseable license to make, have made, use, import, offer for sale, sell, reproduce, distribute, modify, adapt, prepare derivative works of, display, perform, and otherwise exploit such Prior Inventions solely as incorporated into Inventions.',
          termsOwnershipInventionContent10: 'e. Reusable Modules.',
          termsOwnershipInventionContent11:
            'Any open-source components Next Level Technology uses in performing the Services, whether pre-existing or created by Next Level Technology ("Reusable Modules") are licensed to you pursuant to the terms of the applicable open source license. For clarity, and notwithstanding anything to the contrary in these Terms, Next Level Technology may develop new Reusable Modules based on your requests in connection with the Services. Next Level Technology will not incorporate any of your User Content into a Reusable Module without your prior consent.',
          termsOwnershipInventionContent12: '8. Relationship of Parties.',
          termsOwnershipInventionContent13:
            'Next Level Technology, US and you are independent contractors. You understand that Next Level Technology, US is not an employee, and that the performance of Services requires a collaborative, professional relationship of equals where mutual professional respect, courtesy and consideration are expected. Due to the virtual nature of the relationship, you understand the importance of communication, and agree to respond to questions, requests and communications from Next Level Technology, US in a timely manner. You understand that Next Level Technology, US is a business with other clients, and requires fair, realistic notice in order to attend to requests and projects. You understand that Next Level Technology, US may require detailed clarification of tasks in order to meet expectations and provide the best support and highest quality work, and agrees to provide specifications at the level of detail required by Next Level Technology, US.',
          termsOwnershipInventionContent14: '9. Term; Termination.',
          termsOwnershipInventionContent15:
            'The term of these Terms begins on the date you accept these Terms and continues until all subscriptions have expired or been terminated, unless otherwise set forth on an Order Form (the',
          termsOwnershipInventionContent16: 'Term")',
          termsOwnershipInventionContent17:
            "). Unless otherwise specified on an Order Form, subscriptions will automatically renew for additional periods equal to the expiring subscription term, unless either party gives the other notice of non-renewal at least 30 days before the end of the relevant subscription term, by cancelling the user's subscription via the Next Level Technology, US web product.",
          termsOwnershipInventionContent18: 'b. Effect of Termination.',
          termsOwnershipInventionContent19:
            'Upon termination of these Terms, your right to use the Platform will immediately cease and any fees you owe to Next Level Technology, US will become immediately due. Sections 3, 4, 7, 8b, 10 – 14, 15.b, and 16 – 23 will survive any termination or expiration of these Terms. Next Level Technology, US may delete any User Content hosted on the Platform.',
          termsOwnershipInventionContent20: '10. Fees.',
          termsOwnershipInventionContent21:
            'The fees for the Platform and any Services are as set forth on the Order Form, or, if you do not have an Order Form, the Platform. You will provide Next Level Technology, US with valid and updated credit card information, and you authorize Next Level Technology, US to charge such credit card for the fees for the initial subscription term, hourly or milestone-based service fees, any renewal subscription term, in advance, in accordance with the billing frequency set forth on the Order Form, or if there is no Order Form, the Platform. Subscriptions, hourly fees, and milestone-based fees are non-refundable once hours are worked and charged (for hourly fees) or when milestones are funded for work (for milestone fees).',
          termsOwnershipInventionContent22: '11. No Support or Maintenance.',
          termsOwnershipInventionContent23:
            'Unless you have a subscription that provides for support, you acknowledge and agree that Next Level Technology, US will have no obligation to provide you with any support or maintenance in connection with the Platform except as part of the Services.',
          termsOwnershipInventionContent24: '12. Acceptable Use Policy.',
          termsOwnershipInventionContent25:
            'The following terms constitute Next Level Technology, US',
          termsOwnershipInventionContent26: 'Acceptable Use Policy',
          termsOwnershipInventionContent27:
            "You will not use the Platform to collect, upload, transmit, display, or distribute any User Content (i) that violates any third-party right, including any copyright, trademark, patent, trade secret, moral right, privacy right, right of publicity, or any other intellectual property or proprietary right; (ii) that is unlawful, harassing, abusive, tortious, threatening, harmful, invasive of another's privacy, vulgar, defamatory, false, intentionally misleading, trade libelous, pornographic, obscene, patently offensive, promotes racism, bigotry, hatred, or physical harm of any kind against any group or individual or is otherwise objectionable; (iii) that is harmful to minors in any way; or (iv) that is in violation of any law, regulation, or obligations or restrictions imposed by any third party.",
          termsOwnershipInventionContent28:
            "In addition, you will not: (i) upload, transmit, or distribute to or through the Platform any computer viruses, worms, or any software intended to damage or alter a computer system or data; (ii) send through the Platform unsolicited or unauthorized advertising, promotional materials, junk mail, spam, chain letters, pyramid schemes, or any other form of duplicative or unsolicited messages, whether commercial or otherwise; (iii) use the Platform to harvest, collect, gather or assemble information or data regarding other users, including e-mail addresses, without their consent; (iv) interfere with, disrupt, or create an undue burden on servers or networks connected to the Platform, or violate the regulations, policies or procedures of such networks; (v) attempt to gain unauthorized access to the Platform (or to other computer systems or networks connected to or used together with the Platform), whether through password mining or any other means; (vi) harass or interfere with any other user's use and enjoyment of the Platform; or (vi) use software or automated agents or scripts to produce multiple accounts on the Platform, or to generate automated searches, requests, or queries to (or to strip, scrape, or mine data from) the Platform (provided, however, that we conditionally grant to the operators of public search engines revocable permission to use spiders to copy materials from the Platform for the sole purpose of and solely to the extent necessary for creating publicly available searchable indices of the materials, but not caches or archives of such materials, subject to the parameters set forth in our robots.txt file).",
          termsOwnershipInventionContent29:
            'Enforcement. We reserve the right (but have no obligation) to review any User Content, and to investigate and/or take appropriate action against you in our sole discretion if you violate this Acceptable Use Policy or any other provision of these Terms or otherwise create liability for us or any other person. Such action may include removing or modifying your User Content, terminating your Account in accordance with Section 9, and/or reporting you to law enforcement authorities.',
          termsOwnershipInventionContent30: '‍13. Feedback; Name.',
          termsOwnershipInventionContent31:
            'If you provide Next Level Technology, US with any feedback or suggestions regarding the Platform or Services (',
          termsOwnershipInventionContent32: '"Feedback")',
          termsOwnershipInventionContent33:
            "), then you grant Next Level Technology, US a perpetual, irrevocable, non-exclusive, transferable, sublicensable, worldwide license to use such Feedback in any manner it deems appropriate. Next Level Technology, US will treat any Feedback as non-confidential and non-proprietary. Unless you provide Next Level Technology, US with an opt-out notice, you grant Next Level Technology, US a right to use your name, logo, and application screenshots in Next Level Technology, US' marketing materials. Any such opt-out notice will not apply to use by Next Level Technology, US in accordance with this Section prior to Next Level Technology, US' receipt of notice.",
          termsOwnershipInventionContent34:
            '14. Representations and Warranties.',
          termsOwnershipInventionContent35:
            'You represent and warrant that you have the full right and authority to enter into and perform these Terms, and that entering into these Terms does not violate any outstanding assignments, grants, licenses, encumbrances, obligations, agreements or understanding to which you are a party. Next Level Technology, US warrants that during an applicable subscription term Next Level Technology, US will not materially decrease the overall functionality of the Platform. For any breach of that warranty, your exclusive remedies are those described in Section 9.',
          termsOwnershipInventionContent36: '15. Free Services.',
          termsOwnershipInventionContent37:
            'a. Next Level Technology, US may make certain parts of the Platform available for free (',
          termsOwnershipInventionContent38: '"Free Products")',
          termsOwnershipInventionContent39:
            '). Use of Free Products is subject to the terms and conditions of these Terms. In the event of a conflict between this section and any other portion of these Terms, this section controls. Free Products are provided to you without charge as described on the Platform. You agree that Next Level Technology, US, in its sole discretion and for any or no reason, may terminate your access to the Free Products or any part thereof, with or without prior notice. Next Level Technology, US will not be liable to you or any third party for such termination. You are solely responsible for exporting your User Content and any Apps from the Free Products prior to termination of your access to the Free Products for any reason, provided that if Next Level Technology, US terminates your account, except as required by law, Next Level Technology, US will provide you a reasonable opportunity to retrieve your Apps.',
          termsOwnershipInventionContent40:
            'NOTWITHSTANDING SECTIONS 14, 16, AND 18.b, THE FREE PRODUCTS ARE PROVIDED "AS-IS" AND WITHOUT ANY WARRANTY, AND NEXT LEVEL Technology, US HAS NO INDEMNIFICATION OBLIGATIONS NOR LIABILITY OF ANY TYPE WITH RESPECT TO THE FREE PRODUCTS UNLESS SUCH EXCLUSION OF LIABILITY IS NOT ENFORCEABLE UNDER APPLICABLE LAW IN WHICH CASE NEXT LEVEL Technology, US\' LIABILITY WITH RESPECT TO THE FREE PRODUCTS WILL NOT EXCEED US$100. WITHOUT LIMITING THE FOREGOING, NEXT LEVEL Technology, US AND ITS SUPPLIERS DO NOT REPRESENT OR WARRANT TO YOU THAT: (I) YOUR USE OF THE FREE PRODUCTS WILL MEET YOUR REQUIREMENTS, (II) YOUR USE OF THE FREE PRODUCTS WILL BE UNINTERRUPTED, TIMELY, SECURE OR FREE FROM ERROR, AND (III) ANY DATA PROVIDED THROUGH THE FREE PRODUCTS WILL BE ACCURATE. NOTWITHSTANDING ANYTHING TO THE CONTRARY IN SECTION 17, YOU ARE FULLY LIABLE UNDER THESE TERMS TO NEXT LEVEL Technology, US FOR ANY DAMAGES ARISING OUT OF YOUR USE OF THE FREE PRODUCTS, ANY BREACH BY YOU OF THESE TERMS AND ANY OF YOUR INDEMNIFICATION OBLIGATIONS HEREUNDER.',
          termsOwnershipInventionContent41: '16. Disclaimers.',
          termsOwnershipInventionContent42:
            'EXCEPT AS EXPRESSLY PROVIDED IN THESE TERMS, NEITHER PARTY MAKES ANY WARRANTY OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, AND EACH PARTY SPECIFICALLY DISCLAIMS ALL IMPLIED WARRANTIES, INCLUDING ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NON-INFRINGEMENT, TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW.',
          termsOwnershipInventionContent43: '17. Limitation of Liability.',
          termsOwnershipInventionContent44:
            'TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL NEXT LEVEL Technology, US (OR ITS SUPPLIERS) BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY LOST PROFITS, LOST DATA, COSTS OF PROCUREMENT OF SUBSTITUTE PRODUCTS, OR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES ARISING FROM OR RELATING TO THESE TERMS OR YOUR USE OF, OR INABILITY TO USE, THE PLATFORM OR SERVICES, EVEN IF NEXT LEVEL Technology, US HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. ACCESS TO, AND USE OF, THE PLATFORM AND SERVICES IS AT YOUR OWN DISCRETION AND RISK, AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR DEVICE OR COMPUTER SYSTEM, OR LOSS OF DATA RESULTING THEREFROM.',
          termsOwnershipInventionContent45:
            "TO THE FULLEST EXTENT PERMITTED BY LAW, NOTWITHSTANDING ANYTHING TO THE CONTRARY, NEXT LEVEL TECHNOLOGY, US' LIABILITY TO YOU FOR ANY DAMAGES ARISING FROM OR RELATED TO THESE TERMS (FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION), WILL AT ALL TIMES BE LIMITED TO THE GREATER OF (I) THE FEES YOU HAVE PAID NEXT LEVEL TECHNOLOGY, US IN THE 12 MONTHS PRIOR TO THE EVENT GIVING RISE TO LIABILITY AND (II) US$50. THE EXISTENCE OF MORE THAN ONE CLAIM WILL NOT ENLARGE THIS LIMIT. YOU AGREE THAT OUR SUPPLIERS WILL HAVE NO LIABILITY OF ANY KIND ARISING FROM OR RELATING TO THESE TERMS.",
          termsOwnershipInventionContent46: '18. Indemnification.',
          termsOwnershipInventionContent47: 'By You.',
          termsOwnershipInventionContent48:
            "To The fullest extent permitted by law, you will indemnify Next Level Technology, US from and against any and all liabilities, suits, losses, damages and judgments, costs and expenses (including reasonable outside counsel's fees and expenses) in connection with (i) your use of the Platform or Services in a manner not authorized under these Terms, (ii) any other breach of these Terms by you, and (iii) your use of Prior Inventions or Reusable Modules in a manner not authorized under these Terms.",
          termsOwnershipInventionContent49:
            "By Next Level Technology, US. Unless you are using a Free Product, Next Level Technology, US will indemnify and defend you against any claim, demand, suit or proceeding made or brought against you by a third party alleging that the Platform or any Prior Invention infringes or misappropriates such third party's intellectual property rights (an \"IP Claim\"), provided that you (i) promptly give Next Level Technology, US written notice of the IP Claim, (ii) give Next Level Technology, US sole control of the defense and settlement of the IP Claim, and (iii) give Next Level Technology, US all reasonable assistance, at Next Level Technology, US' expense. The foregoing obligations do not apply if (1) the allegation does not state with specificity that the Platform or a Prior Invention are the basis of the IP Claim; (2) an IP Claim arises from the use or combination of the Platform or Prior Invention (other than as incorporated into an Invention) with software, hardware, data, or processes not provided by Next Level Technology, US, if the Platform, Prior Invention or use thereof would not infringe without such combination; (3) an IP Claim arises from Services for which there is no charge; or (4) an IP Claim arises from User Content or your breach of these Terms. If Next Level Technology, US believes an infringement or misappropriation claim related to the Platform or a Prior Invention is likely, then Next Level Technology, US may: (A) modify the Platform or Prior Invention to be non-infringing, (B) obtain a license for your continued use of the Platform or Prior Invention, or (C) terminate your subscription for the Platform upon 30 days' written notice and refund you any prepaid fees covering the remainder of the term of the terminated subscriptions.‍",
          termsOwnershipInventionContent50: '19. Confidentiality.',
          termsOwnershipInventionContent51:
            'a. Definition. "Confidential Information"',
          termsOwnershipInventionContent52:
            'means all information disclosed by a party (',
          termsOwnershipInventionContent53: '"Disclosing Party")',
          termsOwnershipInventionContent54: 'to the other party (',
          termsOwnershipInventionContent55: '"Receiving Party"',
          termsOwnershipInventionContent56:
            "), whether orally or in writing, that is designated as confidential or that reasonably should be understood to be confidential given the nature of the information and the circumstances of disclosure. Next Level Technology, US' Confidential Information includes the Platform and any Prior Inventions, and the terms and conditions of all Order Forms (including pricing). Confidential Information of each party includes business and marketing plans, technology and technical information, product plans and designs, and business processes disclosed by such party. However, Confidential Information does not include any information that (i) is or becomes generally known to the public without breach of any obligation owed to the Disclosing Party, (ii) was known to the Receiving Party prior to its disclosure by the Disclosing Party without breach of any obligation owed to the Disclosing Party, (iii) is received from a third party without breach of any obligation owed to the Disclosing Party, or (iv) was independently developed by the Receiving Party.",
          termsOwnershipInventionContent57: 'b. Non-Use and Non-Disclosure.',
          termsOwnershipInventionContent58:
            "As between the parties, each party retains all ownership rights in and to its Confidential Information. The Receiving Party will use the same degree of care that it uses to protect the confidentiality of its own confidential information of like kind (but not less than reasonable care) to (i) not use any Confidential Information of the Disclosing Party for any purpose outside the scope of these Terms and (ii) except as otherwise authorized by the Disclosing Party in writing, limit access to Confidential Information of the Disclosing Party to those of its employees and contractors who need that access for purposes consistent with these Terms and who have signed confidentiality agreements with the Receiving Party containing protections not materially less protective of the Confidential Information than those in these Terms. Neither party will disclose the terms of these Terms or any Order Form to any third party other than its affiliates, legal counsel and accountants without the other party's prior written consent.",
          termsOwnershipInventionContent59: 'c. Compelled Disclosure.',
          termsOwnershipInventionContent60:
            "The Receiving Party may disclose Confidential Information of the Disclosing Party to the extent compelled by law to do so, provided the Receiving Party gives the Disclosing Party prior notice of the compelled disclosure (to the extent legally permitted) and reasonable assistance, at the Disclosing Party's cost, if the Disclosing Party wishes to contest the disclosure. If the Receiving Party is compelled by law to disclose the Disclosing Party's Confidential Information as part of a civil proceeding to which the Disclosing Party is a party, and the Disclosing Party is not contesting the disclosure, the Disclosing Party will reimburse the Receiving Party for its reasonable cost of compiling and providing secure access to that Confidential Information.",
          termsOwnershipInventionContent61: '20. Electronic Communications.',
          termsOwnershipInventionContent62:
            'By using the Platform, you consent to receiving electronic communications from Next Level Technology, US (either by posting notices on the Platform or via email). You agree that any notices Next Level Technology, US is required to provide you may be provided electronically.',
          termsOwnershipInventionContent63: '21. Export.',
          termsOwnershipInventionContent64:
            'The Platform and any Inventions, Prior Inventions and Reusable Modules may be subject to U.S. export control laws and may be subject to export or import regulations in other countries. You agree not to export, reexport, or transfer, directly or indirectly, any U.S. technical data acquired from Next Level Technology, US, or any products utilizing such data, in violation of the United States export laws or regulations.',
          termsOwnershipInventionContent65: '22. Arbitration.',
          termsOwnershipInventionContent66: 'a. We Both Agree To Arbitrate.',
          termsOwnershipInventionContent67:
            'You and Next Level Technology, US agree to resolve any claims relating to these Terms, the Platform or any Services through final and binding arbitration by a single arbitrator, except as set forth under Section 22.e. This includes disputes arising out of, or relating to interpretation or application of this "Arbitration" section, including its enforceability, revocability, or validity.',
          termsOwnershipInventionContent68: 'b. Informal Resolution.',
          termsOwnershipInventionContent69:
            'Before filing a claim, each party agrees to try to resolve the dispute by contacting the other party. If a dispute is not resolved within thirty days of notice, either party may bring a formal proceeding.',
          termsOwnershipInventionContent70: 'c. Arbitration Location.',
          termsOwnershipInventionContent71: 'The',
          termsOwnershipInventionContent72: 'American Arbitration Association',
          termsOwnershipInventionContent73:
            '(AAA) will administer the arbitration under its Commercial Arbitration Rules. The arbitration will be held in San Francisco (CA), or any other location both parties agree to in writing.',
          termsOwnershipInventionContent74: ' ‍d. Exception to Arbitration.',
          termsOwnershipInventionContent75:
            'Either Party may bring a lawsuit in the federal or state courts of Alameda County, North Carolina solely for injunctive relief to stop unauthorized use or abuse of the Platform or infringement of intellectual property rights without first engaging in the informal dispute notice process described above. Both you and Next Level Technology, US consent to venue and personal jurisdiction there.',
          termsOwnershipInventionContent76: 'e. NO CLASS ACTIONS.',
          termsOwnershipInventionContent77:
            'You may only resolve disputes with Next Level Technology, US on an individual basis and will not bring a claim in a class, consolidated or representative action. Class arbitrations, class actions, private attorney general actions and consolidation with other arbitrations are not allowed.',
          termsOwnershipInventionContent78: '23. Miscellaneous.',
          termsOwnershipInventionContent79:
            "No failure or delay by either party in exercising any right under these Terms will constitute a waiver of that right. If any term or provision of these Terms is determined to be illegal or invalid, such illegality or invalidity will not affect the validity of the remainder of these Terms. These Terms are governed by North Carolina law. These Terms, which include any Order Form, are the entire agreement between the parties hereto with respect to the subject matter hereof. Neither party may assign these Terms without the other party's consent, except that Next Level Technology, US may assign these Terms without consent in connection with any merger where Next Level Technology, US is not the surviving entity, reorganization, or sale of all or substantially all of its assets. These Terms will be binding upon each party's successors and permitted assigns.",
          termsOwnershipInventionContent80: 'Welcome',
          termsOwnershipInventionContent81: 'Create a new account',
          termsOwnershipInventionContent82:
            'By signing up you agree to the Next Level Technology',
          termsOwnershipInventionContent83: 'Terms and conditions',
          termsOwnershipInventionContent84: 'Already have an account?',
          termsOwnershipInventionContent85: 'Sign in now',
          termsOwnershipInventionContent86: 'Sign Up',
          Productdetails: {
            dashboard: 'Dashboard',
            products: 'Products',
            addImage: 'Add image',
            name: 'Name',
            pointCost: 'Points cost',
            availableStock: 'Available stock',
            enabled: 'Enabled',
            isGift: 'Is gift',
            save: 'Save',
            productAdded: 'Product added',
            remove: 'Remove',
            showPrevious: 'Show previous 10 results',
            showNext: 'Show next 10 results',
            description: 'Description',
            noReviews: 'No reviews found',
            productReviews: 'Product reviews',
            user: 'User',
            score: 'Score',
            date: 'Date',
            comment: 'Comment',
            action: 'Action',
            maxCharacters: 'max {{count}} characters',
            charactersCount: '{{current}}/{{max}} characters',
          },
          products: {
            dashboard: 'Dashboard',
            products: 'Products',
            addProduct: 'Add Product',
            name: 'Name',
            pointCost: 'Point Cost',
            availableStock: 'Available stock',
            description: 'Description',
            addProductImage: 'Add product Image',
            enabled: 'Enabled',
            isGift: 'Is a gift?',
            save: 'Save',
            loading: 'Loading',
            noData: 'No data found',
            showPrevious: 'Show previous 10 results',
            showNext: 'Show next 10 results',
            product: 'Product',
            status: 'Status',
            cost: 'Cost',
            purchased: 'Purchased',
            available: 'Available',
            action: 'Action',
            remove: 'Remove',
            inputError: 'Please input all values',
            nameError:
              'Name field can only contain alphabets. Please try again',
            productAdded: 'Product added successfully!',
            productDeleted: 'Product Deleted Successfully',
          },
          marketing: {
            dashboard: 'Dashboard',
            marketing: 'Marketing',
            notificationSettings: 'Notification settings',
            sendUsing: 'Send using',
            notification: 'Notification',
            newProducts: 'New products',
            productDiscount: 'Product discount',
            pointsAdded: 'Points added',
            redeemRequestApproved: 'Redeem request approved',
            useRewardPoints: 'Use reward points',
            birthday: 'Birthday',
            referral: 'Referral',
            enterNotificationTitle: 'Enter Notification Title',
            notificationTitle: 'Notification Title',
            notificationTitleEnglish: 'Notification Title (English)',
            notificationTitleSpanish: 'Notification Title (Spanish)',
            notificationBody: 'Notification Body',
            notificationBodyEnglish: 'Notification Body (English)',
            notificationBodySpanish: 'Notification Body (Spanish)',
            sendCustomNotification: 'Send Custom Notification',
            selectUsers: 'Select Users',
            sendNotification: 'Send Notification',
            addNotification: 'Add a notification',
            notificationSent: 'Notification sent successfully',
            deleteItem: 'Delete this item',
          },
          pointsSetup: {
            dashboard: 'Dashboard',
            dashboardEs: 'Panel',
            loyaltyProgramSetup: 'Loyalty Program Setup',
            awardsForLevel: 'AWARDS FOR THIS LEVEL',
            awardsForLevelEs: 'PREMIOS PARA ESTE NIVEL',
            discount: 'Discount',
            discountEs: 'Descuento',
            gift: 'Gift',
            giftEs: 'Regalo',
            noGift: 'No gift',
            noGiftEs: 'Sin regalo',
            selectGift: 'Select gift',
            selectGiftEs: 'Seleccionar regalo',
            changeGift: 'Change gift',
            changeGiftEs: 'Cambiar regalo',
            awardsManagement: 'Awards management',
            awardsManagementEs: 'Gestión de premios',
            addReward: 'ADD REWARD',
            addRewardEs: 'AGREGAR PREMIO',
            addRewardTitle: 'Add Reward',
            addRewardTitleEs: 'Agregar Premio',
            awardType: 'Award Type',
            awardTypeEs: 'Tipo de Premio',
            points: 'Points',
            pointsEs: 'Puntos',
            level: 'Level',
            levelEs: 'Nivel',
            selectLevel: 'SELECT LEVEL',
            selectLevelEs: 'SELECCIONAR NIVEL',
            enabled: 'Enabled',
            enabledEs: 'Habilitado',
            save: 'Save',
            saveEs: 'Guardar',
            loading: 'Loading ...',
            loadingEs: 'Cargando ...',
            status: 'STATUS',
            statusEs: 'ESTADO',
            action: 'ACTION',
            actionEs: 'ACCIÓN',
            remove: 'Remove',
            removeEs: 'Eliminar',
            newAwardCreated: 'New award created',
            newAwardCreatedEs: 'Nuevo premio creado',
            rewardsRemoved: 'Rewards removed successfully',
            rewardsRemovedEs: 'Premios eliminados exitosamente',
            bronze: 'Bronze',
            bronzeEs: 'Bronce',
            silver: 'Silver',
            silverEs: 'Plata',
            gold: 'Gold',
            goldEs: 'Oro',
            never: 'Never',
            neverEs: 'Nunca',
            pointsExpire: 'Points expire',
            pointsExpireEs: 'Puntos expiran',
            addMore: 'Add more',
            addMoreEs: 'Agregar más',
            amount: 'AMOUNT',
            amountEs: 'MONTO',
            extraBonus: 'Extra bonus based on money spent',
            extraBonusEs: 'Bono extra basado en dinero gastado',
            eligibilityPoints: 'Eligibility Points',
            eligibilityPointsEs: 'Puntos de Elegibilidad',
            giftInactive: 'Gift is inactive',
            giftInactiveEs: 'Regalo inactivo',
            itemName: 'Item name',
            itemNameEs: 'Nombre del artículo',
            change: 'Change',
            changeEs: 'Cambiar',
            selectLevel: 'SELECT LEVEL',
            selectLevelEs: 'SELECCIONAR NIVEL',
            levelDisplay: 'Level Display',
            levelDisplayEs: 'Mostrar Nivel',
            awardTypeLabel: 'Award Type',
            awardTypeLabelEs: 'Tipo de Premio',
            discountLabel: 'Discount',
            discountLabelEs: 'Descuento',
            pointsLabel: 'Points',
            pointsLabelEs: 'Puntos',
            levelLabel: 'Level',
            levelLabelEs: 'Nivel',
            enabledLabel: 'Enabled',
            enabledLabelEs: 'Habilitado',
            removeBonus: 'Remove Bonus',
            removeBonusEs: 'Eliminar Bono',
            helpText: 'Help text here',
            helpTextEs: 'Texto de ayuda aquí',
            bronzeLevel: 'Bronze Level',
            bronzeLevelEs: 'Nivel Bronce',
            silverLevel: 'Silver Level',
            silverLevelEs: 'Nivel Plata',
            goldLevel: 'Gold Level',
            goldLevelEs: 'Nivel Oro',
          },
          storeSetup: {
            dashboard: 'Dashboard',
            dashboardEs: 'Panel',
            loyaltyProgramStoreSetup:
              'Configuración del programa de lealtad y tienda',
            loyaltyProgramStoreSetupEs:
              'Configuración del programa de lealtad y tienda',
            storeName: 'Nombre de la tienda',
            storeNameEs: 'Nombre de la tienda',
            storeQRCode: 'Código QR de la tienda',
            storeQRCodeEs: 'Código QR de la tienda',
            storeLogo: 'Logo de la tienda',
            storeLogoEs: 'Logo de la tienda',
            generate: 'Generar',
            generateEs: 'Generar',
            downloadImage: 'Descargar imagen',
            downloadImageEs: 'Descargar imagen',
            uploadLogo: 'Subir logo',
            uploadLogoEs: 'Subir logo',
            storeUpdated: 'Tienda actualizada exitosamente',
            storeUpdatedEs: 'Tienda actualizada exitosamente',
            imageSizeError: 'El tamaño de la imagen debe ser menor a 5 MB',
            imageSizeErrorEs: 'El tamaño de la imagen debe ser menor a 5 MB',
            updateError: 'Error al actualizar la tienda',
            maxLengthExceeded:
              'Se excedió la longitud máxima de {{maxLength}} caracteres',
            characters: 'caracteres',
            charactersEs: 'caracteres',
            invalidFileType: 'Only JPG, PNG and SVG images are allowed',
            invalidFileTypeEs: 'Solo se permiten imágenes JPG, PNG y SVG',
            downloadError: 'Error downloading QR code',
            downloadErrorEs: 'Error al descargar el código QR',
            processingFile: 'Procesando archivo...',
            updatingStore: 'Actualizando tienda...',
            processing: 'Procesando...',
            saving: 'Guardando...',
            uploadLogoDescription:
              'Sube una imagen de logo de tienda (JPG, PNG, o SVG)',
          },

          shopUsers: {
            dashboard: 'Dashboard',
            dashboardEs: 'Panel',
            users: 'Users',
            usersEs: 'Usuarios',
            user: 'User',
            userEs: 'Usuario',
            pending: 'Pending',
            pendingEs: 'Pendiente',
            purchases: 'Purchases',
            purchasesEs: 'Compras',
            level: 'Level',
            levelEs: 'Nivel',
            points: 'Points',
            pointsEs: 'Puntos',
            spent: '$ Spent',
            spentEs: '$ Gastado',
            activeStatus: 'Active Status',
            activeStatusEs: 'Estado Activo',
            noData: 'No data found',
            noDataEs: 'No se encontraron datos',
            showPrevious: 'Show previous 10 results',
            showPreviousEs: 'Mostrar 10 resultados anteriores',
            showNext: 'Show next 10 results',
            showNextEs: 'Mostrar siguientes 10 resultados',
          },
          spanish: 'Español',
          english: 'English',

          notifications: {
            product: {
              updated: 'Product updated successfully',
              enabled: 'Product enabled successfully',
              disabled: 'Product disabled successfully',
              removed: 'Product removed successfully',
            },
            purchase: {
              updated: 'Purchase updated successfully',
              accepted: 'Purchase accepted successfully',
              rejected: 'Purchase rejected successfully',
              bulkAccepted: 'Purchases accepted successfully',
              bulkRejected: 'Purchases rejected successfully',
            },
            loyalty: {
              accepted: 'Loyalty points accepted successfully',
              rejected: 'Loyalty points rejected successfully',
            },
            bonus: {
              removed: 'Bonus removed successfully',
            },
            rewards: {
              updated: 'Successfully Updated Value',
              removed: 'Rewards removed successfully',
              accepted: 'Reward accepted successfully',
              rejected: 'Reward rejected successfully',
              bulkAccepted: 'Rewards accepted successfully',
              bulkRejected: 'Rewards rejected successfully',
            },
            gifts: {
              accepted: 'Gift accepted successfully',
              rejected: 'Gift rejected successfully',
              bulkAccepted: 'Gifts accepted successfully',
              bulkRejected: 'Gifts rejected successfully',
            },
          },
        },
        shopUserDetail: {
          dashboard: 'Dashboard',
          users: 'Users',
          pending: 'PENDING',
          purchased: 'PURCHASED',
          level: 'LEVEL',
          points: 'POINTS',
          spent: '$ SPENT',
          referral: 'REFERRAL',
          userActivity: 'User activity',
          referralCode: 'Referral code',
          moneySpent: 'Money Spent',
          addAmount: 'Add Amount',
          addNote: 'Add Note',
          save: 'Save',
          giveBonus: 'Give Bonus',
          enterNumber: 'Please Enter A Number',
          rewardPoints: 'Reward points',
          gifts: 'Gifts',
          loyaltyPointsPurchases: 'Loyalty points purchases',
          loyaltyPointsPurchasesEs: 'Compras con puntos de lealtad',
          addMoneySpent: 'ADD MONEY SPENT',
          user: 'USER',
          received: 'RECEIVED',
          details: 'DETAILS',
          status: 'STATUS',
          accept: 'Accept',
          reject: 'Reject',
          accepted: 'Accepted',
          rejected: 'Rejected',
          date: 'DATE',
          paid: 'PAID',
          amountSpent: 'AMOUNT SPENT',
          note: 'NOTE',
          noData: 'No data found',
          showPrevious: 'Show previous 10 results',
          showNext: 'Show next 10 results',
          insufficientPoints:
            "User doesn't have sufficient points to purchase this product!",
        },
        notifications: {
          product: {
            updated: 'Product updated successfully',
            enabled: 'Product enabled successfully',
            disabled: 'Product disabled successfully',
            removed: 'Product removed successfully',
          },
          purchase: {
            accepted: 'Purchase accepted successfully',
            rejected: 'Purchase rejected successfully',
            bulkAccepted: 'Purchases accepted successfully',
            bulkRejected: 'Purchases rejected successfully',
            statusChanged: 'Purchase status changed successfully',
          },
          loyaltyPoints: {
            accepted: 'Loyalty points accepted successfully',
            rejected: 'Loyalty points rejected successfully',
          },
          rewards: {
            updated: 'Value updated successfully',
            removed: 'Rewards removed successfully',
            accepted: 'Reward accepted successfully',
            rejected: 'Reward rejected successfully',
            bulkAccepted: 'Rewards accepted successfully',
            bulkRejected: 'Rewards rejected successfully',
          },
          gifts: {
            accepted: 'Gift accepted successfully',
            rejected: 'Gift rejected successfully',
            bulkAccepted: 'Gifts accepted successfully',
            bulkRejected: 'Gifts rejected successfully',
          },
        },
        components: {
          dropdown: {
            filter: 'Filter',
          },
        },
      },
    },
    'es-MX': {
      translation: {
        layout: {
          storeNameNotSetup: 'Nombre de la tienda no configurado',
          setupNow: 'Configurar ahora',
          addProduct: 'Agregar Producto',
          saveChanges: 'Guardar Cambios',
          cancel: 'Cancelar',
          removeProduct: 'Eliminar Producto',
          addMoneySpent: 'Agregar Dinero Gastado',
          remove: 'Eliminar',
        },
        dashboard: {
          user: 'Usuario',
          pending: 'PENDIENTE',
          purchased: 'COMPRADO',
          level: 'NIVEL',
          points: 'PUNTOS',
          spent: '$ GASTADO',
          confirmation: 'CONFIRMACIÓN',
          discount: 'DESCUENTO',
          receivedFor: 'RECIBIDO POR',
          status: 'ESTADO',
          noData: 'No se encontraron datos',
          noDataEs: 'No se encontraron datos',
          showPrevious: 'Mostrar 10 resultados anteriores',
          showNext: 'Mostrar 10 resultados siguientes',
          giftsRedeemed: 'Regalos canjeados',
          pointsRedeemed: 'Puntos canjeados',
          newRequests: 'Nuevos pedidos',
          loading: 'Cargando...',
          latestRequests: 'Últimas Solicitudes',
          accept: 'Aceptar',
          reject: 'Rechazar',
          productPurchase: 'Compra de Producto',
          rewardClaim: 'Reclamo de Recompensa',
          giftClaim: 'Reclamo de Regalo',
        },
        sidebar: {
          menuItems: {
            home: 'Inicio',
            inventory: 'Inventario',
            shopUsers: 'Usuarios de la tienda',
            approveRedeems: 'Aprobar reembolsos',
            pointsSetup: 'Configuración de puntos',
            storeSetup: 'Configuración de la tienda',
            analytics: 'Analytics',
            marketing: 'Marketing',
          },
          store: 'Tienda',
          logout: 'Cerrar sesión',
          menu: 'Menú principal',
        },
        storeSetup: {
          dashboard: 'Panel',
          loyaltyProgramStoreSetup:
            'Configuración del programa de fidelización',
          storeQRCode: 'Código QR de la tienda',
          generate: 'Generar',
          storeName: 'Nombre de la tienda',
          enterStoreName: 'Ingrese el nombre de la tienda',
          storeNameNotSetup: 'Nombre de la tienda no configurado',
          setupNow: 'Configurar ahora',
          uploadLogo: 'Cargar logo',
          storeLogo: 'Logo de la tienda',
          uploadStoreLogo: 'Cargar logo de la tienda',
          downloadImage: 'Descargar imagen',
          storeUpdated: 'Tienda actualizada',
          updateError: 'Error al actualizar la tienda',
          maxLengthExceeded:
            'Se excedió la longitud máxima de {{maxLength}} caracteres',
          characters: 'caracteres',
          imageSizeError: 'El tamaño de la imagen debe ser menor a 5 MB',
          invalidFileType: 'Only JPG, PNG and SVG images are allowed',
          invalidFileTypeEs: 'Solo se permiten imágenes JPG, PNG y SVG',
          downloadError: 'Error downloading QR code',
          downloadErrorEs: 'Error al descargar el código QR',
          processingFile: 'Processing file...',
          updatingStore: 'Updating store...',
          processing: 'Processing...',
          saving: 'Saving...',
          uploadLogoDescription: 'Upload a store logo image (JPG, PNG, or SVG)',
        },
        pointsSetup: {
          dashboard: 'Panel',
          loyaltyProgramSetup: 'Configuración del programa de lealtad',
          bronze: 'Bronce',
          silver: 'Plata',
          gold: 'Oro',
          awardsForLevel: 'Premios por Nivel',
          discount: 'Descuento',
          gift: 'Regalo',
          changeGift: 'Cambiar Regalo',
          noGift: 'Sin Regalo',
          awardsManagement: 'Gestión de Premios',
          status: 'ESTADO',
          discount2: 'DESCUENTO',
          points: 'PUNTOS',
          gift2: 'REGALO',
          action: 'ACCIÓN',
          addReward: 'AGREGAR PREMIO',
          addRewardTitle: 'Agregar Premio',
          awardType: 'TIPO DE PREMIO',
          discount: 'DESCUENTO',
          level: 'NIVEL',
          selectLevel: 'SELECCIONE EL NIVEL',
          enabled: 'HABILITADO',
          save: 'Guardar',
          loading: 'Cargando...',
          newAwardCreated: 'Nuevo premio creado',
          remove: 'Eliminar',
          selectGift: 'Seleccionar Regalo',
          noRewards: 'No se encontraron premios para este nivel',
          selectValidLevel: 'Por favor seleccione un nivel válido',
          awardTypeRequired: 'El tipo de premio es requerido',
          duplicateAward: 'Ya existe un premio con este nombre para este nivel',
          awardTypeEnglish: 'Tipo de Premio (Inglés)',
          awardTypeSpanish: 'Tipo de Premio (Español)',
          networkError: 'Error de red, por favor revise su conexión',
          unauthorized: 'Autenticación requerida',
          forbidden: 'No tiene permiso para realizar esta acción',
          serverError:
            'Error del servidor. Podría deberse a un nombre de premio duplicado.',
          errorCreatingAward: 'Error al crear el premio',
          loadingError: 'Error al cargar los datos',
          statusUpdated: 'Estado del premio actualizado',
          updateError: 'Error al actualizar el premio',
          fetchError: 'Error al obtener los datos de premios',
          loadingLevelsError: 'Error al cargar los niveles',
          // Validation error messages
          discountValidNumber: 'El descuento debe ser un número válido',
          discountNegative: 'El descuento no puede ser negativo',
          discountExceedsMax: 'El descuento no puede exceder el 100%',
          pointsValidNumber: 'Los puntos deben ser un número válido',
          pointsNegative: 'Los puntos no pueden ser negativos',
          pointsWholeNumber: 'Los puntos deben ser un número entero',
          awardTypeEmpty: 'El tipo de premio no puede estar vacío',
          errorLoadingLevels: 'Error al cargar los niveles',
          genericError: 'Ocurrió un error inesperado',
          serverResponseError: 'El servidor devolvió un error',
          unknownLevel: 'Nivel Desconocido',
          noAwardType: 'Tipo de premio no disponible',
        },
        approve: {
          title: 'Automatizar aprobaciones',
          rewards: 'Recompensas',
          gifts: 'Regalos',
          purchase: 'Compras',
          acceptSelected: 'Aprobar seleccionados',
          rejectSelected: 'Rechazar seleccionados',
          noData: 'No se encontraron datos',
          showPrevious: 'Mostrar 10 resultados anteriores',
          showNext: 'Mostrar 10 resultados siguientes',
          received: 'Recibido',
          points: 'Puntos',
          user: 'Usuario',
          detail: 'Detalle',
          date: 'Fecha',
          status: 'Estado',
          level: 'Nivel',
          confirmation: 'Confirmación',
          paid: 'Pagado',
          purchased: 'Comprado',
          accept: 'Aceptar',
          reject: 'Rechazar',
          // New translation keys added for bulk selection functionality
          noItemsSelected:
            'Por favor seleccione al menos un elemento para aprobar/rechazar',
          selectedItemsApproved:
            'Elementos seleccionados aprobados exitosamente',
          selectedItemsRejected:
            'Elementos seleccionados rechazados exitosamente',
          errorApprovingItems:
            'Error al aprobar elementos seleccionados. Por favor intente nuevamente.',
          errorRejectingItems:
            'Error al rechazar elementos seleccionados. Por favor intente nuevamente.',
          itemsSelected: 'elemento(s) seleccionado(s)',
          insufficientPoints:
            'El usuario no tiene puntos suficientes para esta compra',
          bulkPurchasesApproved:
            '{{count}} compra(s) aprobada(s) exitosamente',
          bulkPurchasesRejected:
            '{{count}} compra(s) rechazada(s) exitosamente',
          bulkPurchasesSkipped:
            '{{count}} compra(s) ya estaban en ese estado',
          bulkPurchasesFailed:
            '{{count}} compra(s) no pudieron actualizarse',
          bulkPurchasesNoChanges: 'No se actualizó ninguna compra',
          searchCustomer: 'Buscar por nombre o correo del cliente',
          clearSearch: 'Limpiar búsqueda',
        },
        shopUsers: {
          dashboard: 'Panel',
          users: 'Usuarios',
          user: 'Usuario',
          pending: 'PENDIENTE',
          purchases: 'COMPRADO',
          level: 'NIVEL',
          points: 'PUNTOS',
          spent: 'USADO',
          activeStatus: 'Estado activo',
          noData: 'No se encontraron datos',
          showPrevious: 'Mostrar 10 resultados anteriores',
          showNext: 'Mostrar 10 resultados siguientes',
        },
        products: {
          dashboard: 'Panel',
          products: 'Productos',
          searchProduct: 'Buscar por nombre de producto',
          noData: 'No se encontraron datos',
          product: 'Producto',
          status: 'Estado',
          cost: 'Costo',
          purchased: 'Adquirido',
          available: 'Disponible',
          action: 'Acción',
          addProduct: 'Agregar producto',
          name: 'Nombre',
          nameEnglish: 'Nombre (Inglés)',
          nameSpanish: 'Nombre (Español)',
          pointCost: 'Costo en puntos',
          availableStock: 'Stock disponible',
          description: 'Descripción',
          descriptionEnglish: 'Descripción (Inglés)',
          descriptionSpanish: 'Descripción (Español)',
          addProductImage: 'Agregar imagen del producto',
          category: 'Categoría',
          enabled: 'Habilitado',
          isGift: '¿Es regalo?',
          save: 'Guardar',
          productAdded: 'Producto agregado',
          remove: 'Eliminar',
          showPrevious: 'Mostrar 10 resultados anteriores',
          showNext: 'Mostrar 10 resultados siguientes',
          bothNamesRequired: 'Ambos nombres son requeridos',
          maxCharacters: 'máx {{count}} caracteres',
          charactersCount: '{{current}}/{{max}} caracteres',
        },
        Productdetails: {
          dashboard: 'Panel',
          products: 'Productos',
          addImage: 'Agregar imagen',
          name: 'Nombre',
          nameEnglish: 'Nombre (Inglés)',
          nameSpanish: 'Nombre (Español)',
          pointCost: 'Costo en puntos',
          availableStock: 'Stock disponible',
          description: 'Descripción',
          descriptionEnglish: 'Descripción (Inglés)',
          descriptionSpanish: 'Descripción (Español)',
          category: 'Categoría',
          enabled: 'Habilitado',
          isGift: '¿Es regalo?',
          save: 'Guardar',
          productAdded: 'Producto agregado',
          remove: 'Eliminar',
          showPrevious: 'Mostrar 10 resultados anteriores',
          showNext: 'Mostrar 10 resultados siguientes',
          noReviews: 'No se encontraron reseñas',
          reviews: 'Reseñas',
          review: 'Reseña',
          noComments: 'No se encontraron comentarios',
          comments: 'Comentarios',
          anonymous: 'Anónimo',
          productReviews: 'Reseñas del producto',
          user: 'Usuario',
          score: 'Puntuación',
          date: 'Fecha',
          comment: 'Comentario',
          action: 'Acción',
          addComment: 'Agregar comentario',
          addCommentTitle: 'Agregar comentario',
          addCommentDescription: 'Agregue un comentario sobre el producto',
          addCommentButton: 'Agregar comentario',
          addCommentSuccess: 'Comentario agregado',
          deleteImage: 'Eliminar imagen',
          deleteImageConfirm: '¿Está seguro de que desea eliminar esta imagen?',
          imageDeleted: 'Imagen eliminada exitosamente',
          imageDeleteError: 'Error al eliminar la imagen',
        },
        common: {
          english: 'Inglés',
          spanish: 'Español',
          loading: 'Cargando...',
          save: 'Guardar',
          cancel: 'Cancelar',
          delete: 'Eliminar',
          edit: 'Editar',
          search: 'Buscar',
          filter: 'Filtrar',
          actions: 'Acciones',
          yes: 'Sí',
          no: 'No',
          success: 'Éxito',
          error: 'Error',
          warning: 'Advertencia',
          info: 'Información',
          invalidFileType: 'Only JPG, PNG and SVG images are allowed',
          invalidFileTypeEs: 'Solo se permiten imágenes JPG, PNG y SVG',
          fileSizeError: 'File size should be less than 5 MB',
          fileSizeErrorEs: 'El tamaño del archivo debe ser menor a 5 MB',
          fileProcessingError: 'Error processing file',
          fileProcessingErrorEs: 'Error al procesar el archivo',
        },
        auth: {
          login: 'Iniciar sesión',
          logout: 'Cerrar sesión',
          email: 'Correo electrónico',
          password: 'Contraseña',
          forgotPassword: '¿Olvidó su contraseña?',
          rememberMe: 'Recuérdame',
          signIn: 'Iniciar sesión',
          signUp: 'Registrarse',
          welcome: 'Bienvenido',
          loginToAccount: 'Iniciar sesión en su cuenta',
          createAccount: 'Crear una nueva cuenta',
          dontHaveAccount: '¿No tiene una cuenta?',
          alreadyHaveAccount: '¿Ya tiene una cuenta?',
          signUpNow: 'Regístrese ahora',
          signInNow: 'Inicie sesión ahora',
          firstName: 'Nombre',
          lastName: 'Apellido',
          enterFirstName: 'Ingrese su nombre',
          enterLastName: 'Ingrese su apellido',
          enterEmail: 'Ingrese su correo electrónico',
          enterPassword: 'Ingrese su contraseña',
          confirmPassword: 'Confirmar contraseña',
          newPassword: 'Nueva contraseña',
          enterNewPassword: 'Ingrese la nueva contraseña',
          resetMyPassword: 'Restablecer mi contraseña',
          setupNewPassword: 'Configurar una nueva contraseña',
          termsAndConditions: 'Términos y condiciones',
          agreeToTerms:
            'Al registrarse, acepta los Términos de Next Level Technology',
          checkEmail: '¡Revise su correo electrónico!',
          resetLinkSent:
            'Se ha enviado un enlace para restablecer la contraseña a su correo electrónico, por favor revise su bandeja de entrada para proceder.',
          resetPasswordTitle: '¿Olvidó mi contraseña?',
          resetPasswordDesc:
            'Ingrese el correo electrónico que utilizó para registrarse y le enviaremos un enlace para restablecer la contraseña.',
          loginError: 'Error de inicio de sesión',
          registerError: 'Error de registro',
          resetError: 'No se pudo restablecer la contraseña',
          resetPasswordError: 'No se pudo restablecer la contraseña',
          passwordResetSuccess:
            'La contraseña ha sido restablecida exitosamente',
          invalidResetLink:
            'Enlace de restablecimiento de contraseña no válido. Por favor solicite uno nuevo.',
          tokenError: 'No se pudo enviar el token',
          passwordMatch: 'La contraseña no coincide',
          enterEmailAddress:
            'Por favor, ingrese la dirección de correo electrónico',
          resetLinkSuccess:
            'Se ha enviado un enlace para restablecer a su correo electrónico',
          resetPassword: 'Restablecer mi contraseña',
          termsTitle:
            'TÉRMINOS DE USO DE SOFTWARE Y SERVICIOS DE NEXT LEVEL TECHNOLOGY, INC., CORPORACIÓN DE EE. UU.',
          termsContent:
            'AL ACEPTAR ESTOS TÉRMINOS, AL (1) HACER CLIC EN UN CUADRO O BOTÓN INDICANDO ACEPTACIÓN, (2) EJECUTANDO UN FORMULARIO DE ORDEN QUE REFERENCIA ESTOS TÉRMINOS, O (3) USANDO UN PRODUCTO GRATUITO, ACEPTA ESTOS TÉRMINOS. SI SE REGISTRA PARA NEXT LEVEL Technology, US\' PRODUCTO GRATUITO, LAS PROVISONES APLICABLES DE ESTOS TÉRMINOS TAMBIÉN REGIRÁN ESE PRODUCTO GRATUITO. SI LA PERSONA QUE ACEPTE ESTOS TÉRMINOS ESTÁ ACEPTANDO EN NOMBRE DE UNA EMPRESA O OTRA ENTIDAD LEGAL, ESA PERSONA REPRESENTA QUE TIENE LA AUTORIDAD PARA ENLAZAR ESA ENTIDAD Y SUS AFILES A ESTOS TÉRMINOS, EN CUYO CASO EL TÉRMINO "Usted" SE REFIERE A ESA ENTIDAD Y SUS AFILES. SI LA PERSONA QUE ACEPTE ESTOS TÉRMINOS NO TIENE TAL AUTORIDAD, O NO ESTÁ DE ACUERDO CON ESTOS TÉRMINOS, ESA PERSONA NO DEBE ACEPTAR ESTOS TÉRMINOS Y NO DEBE USAR LA PLATAFORMA.',
          termsPlatform: '1. Plataforma.',
          termsPlatformContent:
            'Sujeto a los términos y condiciones de estos Términos, Next Level Technology, US concede a usted durante el Término (definido a continuación) una limitada, no exclusiva, no transferable, no sublicensable derecho para acceder y usar la plataforma de desarrollo de software de Next Level Technology, US, sitio web, plataforma de desarrollo de ingeniería y biblioteca de módulos (conjuntamente, la',
          termsPlatformContent2: '"Plataforma")',
          termsPlatformContent3:
            'para el propósito de gestionar, alojar, desarrollar, lanzar y analizar sus aplicaciones de software propietario (',
          termsPlatformContent4: '"Apps"',
          termsPlatformContent5:
            '). La forma y el medio en que Next Level Technology, US elige completar los Servicios están bajo su exclusiva discreción y control. Las obligaciones de Next Level Technology, US para proporcionar los Servicios están condicionadas a recibir la información y cooperación de usted como sea necesario para realizar los Servicios.',
          termsRestrictions: '3. Restricciones.',
          termsRestrictionsContent:
            'Los derechos otorgados a usted en estos Términos están sujetos a las siguientes restricciones: (a) no puede licenciar, vender, rentar, arrendar, transferir, asignar, distribuir, alojar o comercialmente explotar la Plataforma, ya sea en su totalidad o en parte, o cualquier contenido mostrado en la Plataforma; (b) no puede modificar, hacer obras derivadas de, desensamblar, compilar o desensamblar cualquier parte de la Plataforma; y (c) excepto como se establece expresamente en este documento, no se puede copiar, reproducir, distribuir, publicar, descargar, mostrar, publicar o transmitir cualquier forma o por cualquier medio. A menos que se indique lo contrario, cualquier liberación, actualización o otra adición a la funcionalidad de la Plataforma está sujeta a estos Términos. A menos que se especifique lo contrario en la Plataforma, todos los avisos y derechos de propiedad intelectual en la Plataforma (o en cualquier contenido mostrado en la Plataforma) deben conservarse en todas las copias de ella.',
          termsResponsibilities: '4. Sus responsabilidades.',
          termsResponsibilitiesContent:
            'Usted será responsable de la cumplimiento de sus usuarios autorizados (',
          termsResponsibilitiesContent2: '"Usuarios")',
          termsResponsibilitiesContent3:
            ') de estos Términos y formularios de pedido, (b) será responsable de la precisión, calidad y legalidad del contenido del usuario (definido a continuación), (c) será responsable de su uso de sus Apps (incluyendo cualquier Invencción y cualquier Invencción anterior o módulo reutilizable (cada uno definido a continuación) incorporado en una Invencción) y la interoperación de su App con cualquier aplicación de terceros, (d) usar esfuerzos comercialmente razonables para prevenir el acceso no autorizado o el uso de la Plataforma y notificarle a Next Level Technology, US de inmediato cualquier acceso no autorizado o uso, y (e) usar la Plataforma y Servicios solo de acuerdo con estos Términos y las leyes y regulaciones aplicables y reglamentos gubernamentales. El uso de la Plataforma en violación de lo anterior por usted o Usuarios que en la opinión de Next Level Technology, US amenaza la seguridad, integridad o disponibilidad de los Servicios de Next Level Technology, US, puede resultar en la inmediata suspensión de la Plataforma por parte de Next Level Technology, US, sin embargo Next Level Technology, US usará esfuerzos comercialmente razonables en circunstancias para proporcionarle aviso y oportunidad para remediar tales violación o amenaza antes de que cualquier suspensión.',
          termsAccount: '5. Cuentas.',
          termsRegister: 'a. Registro.',
          termsRegisterContent:
            'Para usar ciertas características de la Plataforma, debe registrarse para una cuenta ("Cuenta") y proporcionar cierta información sobre usted como se le solicite en el formulario de registro de la cuenta. Usted representa y garantiza que: (i) toda información de registro requerida que presente es sincera y precisa; (ii) mantendrá la precisión de dicha información. Puede eliminar su Cuenta en cualquier momento, por cualquier razón, siguiendo las instrucciones en la Plataforma. Next Level Technology, US puede suspender o terminar su Cuenta de acuerdo con la Sección 9.',
          termsAccountResponsibilities: 'b. Responsabilidades.',
          termsAccountResponsibilitiesContent:
            'Usted es responsable de mantener la confidencialidad de su información de inicio de sesión de la Cuenta y es responsable de todas las actividades que ocurran bajo su Cuenta. Usted acepta notificarle inmediatamente a Next Level Technology, US de cualquier uso no autorizado o sospechoso de su Cuenta o cualquier otro incumplimiento de seguridad. Next Level Technology, US no puede y no será responsable de ninguna pérdida o daño que surja de su incumplimiento de los requisitos anteriores.',
          termsOwnership: '6. Propiedad.',
          termsOwnershipPlatform: 'a. Plataforma.',
          termsOwnershipPlatformContent:
            'Next Level Technology, US retiene todos los derechos en la Plataforma, excepto como se establece expresamente en estos Términos.',
          termsOwnershipApps: 'b. Apps.',
          termsOwnershipAppsContent:
            'Usted posee sus Apps, sujeto a los términos y condiciones de estos Términos.',
          termsOwnershipInvention: 'c. Invencciones.',
          termsOwnershipInventionContent:
            'Todos los derechos de propiedad intelectual en y para cualquier software, algoritmo, código, material, notas, registros, dibujos, diseños, invenciones, mejoras, desarrollos, descubrimientos y secretos comerciales (',
          termsOwnershipInventionContent2: '"Materiales")',
          termsOwnershipInventionContent3:
            'concebidos, descubiertos, creados, inventados, desarrollados o reducidos a la práctica por Next Level Technology, US, solo o en colaboración con otros, durante el Término y surgiendo de, o en conexión con, la realización de los Servicios bajo estos Términos y cualquier derechos de propiedad intelectual relacionados con los mismos (conjuntamente, pero excluyendo Invencciones anteriores y módulos reutilizables',
          termsOwnershipInventionContent4: '"Invencciones")',
          termsOwnershipInventionContent5:
            '), son su propiedad exclusiva. Next Level Technology, US le notificará inmediatamente cualquier Invencción por escrito y le entregará y asignará (o causará que se asigne) y, por la presente, le asigna totalmente todos los derechos, título y interés en y por las Invencciones. Next Level Technology, US le ayudará razonablemente para probar, registrar y perfeccionar tales asignaciones, y para perfeccionar, obtener, mantener, hacer cumplir y defender cualquier derecho asignado. Sin embargo, Next Level Technology, US se reserva el derecho de usar y reutilizar cualquier conocimiento general que gane surgiendo de la realización de los Servicios en su negocio sin responsabilidad para usted.',
          termsOwnershipInventionContent6: 'd. Invencciones anteriores.',
          termsOwnershipInventionContent7:
            'Si, durante la realización de los Servicios, Next Level Technology, US incorpora en cualquier Invencción o usa cualquier material propiedad de Next Level Technology, US o en el que Next Level Technology, US tenga interés (',
          termsOwnershipInventionContent8: '"Invencciones anteriores")',
          termsOwnershipInventionContent9:
            '), entonces Next Level Technology, US le concede una licencia no exclusiva, gratuita, perpetua, irrevocable, transferable, mundial, sublicenseable para hacer, tener, usar, importar, ofrecer a la venta, vender, reproducir, distribuir, modificar, adaptar, preparar obras derivadas de, mostrar, realizar y explotar tales Invencciones anteriores solo como incorporadas en Invencciones.',
          termsOwnershipInventionContent10: 'e. Módulos reutilizables.',
          termsOwnershipInventionContent11:
            'Cualquier componente de código abierto que Next Level Technology usa en la realización de los Servicios, ya sea existente o creado por Next Level Technology ("Módulos reutilizables") se le licencia de acuerdo con los términos de la licencia de código abierto aplicable. Por claridad, y a menos que se establezca lo contrario en estos Términos, Next Level Technology puede desarrollar nuevos Módulos reutilizables basados en sus solicitudes en conexión con los Servicios. Next Level Technology no incorporará ningún contenido del usuario en un Módulo reutilizable sin su consentimiento previo.',
          termsOwnershipInventionContent12: '8. Relación de Partes.',
          termsOwnershipInventionContent13:
            'Next Level Technology, US y usted son contratistas independientes. Usted entiende que Next Level Technology, US no es un empleado y que la realización de los Servicios requiere una relación colaborativa, profesional de igualdad donde se espera respeto profesional, cortesía y consideración mutua. Debido a la naturaleza virtual de la relación, entiende la importancia de la comunicación y acepta responder preguntas, solicitudes y comunicaciones de Next Level Technology, US en un tiempo razonable. Usted entiende que Next Level Technology, US es una empresa con otros clientes y requiere aviso razonable para atender solicitudes y proyectos. Usted entiende que Next Level Technology, US puede requerir una aclaración detallada de tareas para cumplir con las expectativas y proporcionar el mejor soporte y trabajo de mayor calidad, y acepta proporcionar especificaciones al nivel de detalle requerido por Next Level Technology, US.',
          termsOwnershipInventionContent14: '9. Término; Término.',
          termsOwnershipInventionContent15:
            'El término de estos Términos comienza en la fecha en que acepta estos Términos y continúa hasta que todas las suscripciones hayan expirado o hayan sido terminadas, a menos que se establezca lo contrario en un formulario de pedido (el',
          termsOwnershipInventionContent16: 'Término")',
          termsOwnershipInventionContent17:
            '). A menos que se especifique lo contrario en un formulario de pedido, las suscripciones se renovarán automáticamente por períodos adicionales iguales al término de suscripción que está expirando, a menos que cualquiera de las partes dé la otra aviso de no renovación al menos 30 días antes del final del término de suscripción relevante, cancelando la suscripción del usuario a través del producto web de Next Level Technology, US.',
          termsOwnershipInventionContent18: 'b. Efecto del Término.',
          termsOwnershipInventionContent19:
            'Al terminar estos Términos, su derecho a usar la Plataforma se interrumpirá inmediatamente y cualquier cargo que deba a Next Level Technology, US se convertirá en inmediatamente debido. Las Secciones 3, 4, 7, 8b, 10-14, 15b y 16-23 sobrevivirán cualquier terminación o expiración de estos Términos. Next Level Technology, US puede eliminar cualquier contenido del usuario alojado en la Plataforma.',
          termsOwnershipInventionContent20: '10. Cargos.',
          termsOwnershipInventionContent21:
            'Los cargos por la Plataforma y cualquier Servicio se establecen en el formulario de pedido, o, si no tiene un formulario de pedido, la Plataforma. Proporcionará a Next Level Technology, US información y actualización de tarjeta de crédito válida y autorizará a Next Level Technology, US cobrar la tarjeta de crédito para los cargos por la suscripción inicial, cargos de servicio por hora o por servicio basado en hitos, cualquier término de suscripción de renovación, por adelantado, de acuerdo con la frecuencia de facturación establecida en el formulario de pedido, o si no hay formulario de pedido, la Plataforma. Las suscripciones, cargos por hora, y cargos basados en hitos no son reembolsables una vez que se trabaja y se cobra (para cargos por hora) o cuando se financian hitos para el trabajo (para cargos basados en hitos).',
          termsOwnershipInventionContent22: '11. Sin Soporte o Mantenimiento.',
          termsOwnershipInventionContent23:
            'A menos que tenga una suscripción que proporcione soporte, reconoce y acepta que Next Level Technology, US no tendrá ninguna obligación para proporcionarle soporte o mantenimiento en conexión con la Plataforma excepto como parte de los Servicios.',
          termsOwnershipInventionContent24: '12. Política de Uso Aceptable.',
          termsOwnershipInventionContent25:
            'Los siguientes términos constituyen Next Level Technology, US',
          termsOwnershipInventionContent26: 'Política de Uso Aceptable',
          termsOwnershipInventionContent27:
            'No usará la Plataforma para recoger, cargar, transmitir, mostrar o distribuir cualquier contenido del usuario (i) que infringe cualquier derecho de terceros, incluyendo cualquier derecho de propiedad intelectual, marca registrada, patente, secreto comercial, derecho moral, derecho de privacidad, derecho de publicidad o cualquier otro derecho de propiedad intelectual o propietario; (ii) que es ilegal, acosador, abusivo, litigioso, amenazante, dañino, invasivo del derecho a la privacidad de otro, vulgar, calumnioso, falso, intencionadamente engañoso, calumnioso comercial, pornográfico, obsceno, patente ofensivo, promueve el racismo, la xenofobia, la odio, o cualquier daño físico de cualquier tipo contra cualquier grupo o individuo o es de otra manera objetable; (iii) que es dañino para menores de cualquier manera; o (iv) que es en violación de cualquier ley, reglamento o obligaciones o restricciones impuestas por cualquier tercero.',
          termsOwnershipInventionContent28:
            'Además, no lo hará: (i) cargar, transmitir o distribuir a la Plataforma o a través de la Plataforma cualquier software malicioso, gusanos o cualquier software destinado a dañar o alterar un sistema informático o datos; (ii) enviar a través de la Plataforma publicidad, materiales promocionales no solicitados, correo basura, spam, cartas de cadena, pirámides o cualquier otra forma de duplicación o mensajes no solicitados, ya sea comercial o de otro tipo; (iii) usar la Plataforma para recolectar, recoger o ensamblar información o datos sobre otros usuarios, incluyendo direcciones de correo electrónico, sin su consentimiento; (iv) interferir, interrumpir o crear una carga desproporcionada en servidores o redes conectadas a la Plataforma, o violar las regulaciones, políticas o procedimientos de dichas redes; (v) intentar obtener acceso no autorizado a la Plataforma (o a otros sistemas informáticos o redes conectadas o usadas junto con la Plataforma), ya sea mediante minería de contraseñas o de cualquier otra manera; (vi) molestar o interferir con el uso y disfrute de la Plataforma por parte de otros usuarios; o (vi) usar software o agentes automatizados o scripts para producir múltiples cuentas en la Plataforma, o para generar búsquedas, solicitudes o consultas automatizadas para (o para extraer, raspar o minar datos de) la Plataforma (proporcionado, sin embargo, que concedemos de manera condicional a los operadores de motores de búsqueda públicos permiso revocable para usar arañas para copiar materiales de la Plataforma solo con el propósito de y solo para la extensión necesaria para crear índices públicamente accesibles de los materiales, pero no cachés o archivos de esos materiales, sujetos a los parámetros establecidos en nuestro archivo robots.txt).',
          termsOwnershipInventionContent29:
            'Ejecución. Nos reservamos el derecho (pero no tenemos la obligación) de revisar cualquier contenido del usuario y tomar las acciones apropiadas en nuestra discreción solo si viola esta Política de Uso Aceptable o cualquier otra disposición de estos Términos o de lo contrario crea responsabilidad para nosotros o para cualquier otra persona. Dicha acción puede incluir eliminar o modificar su contenido del usuario, terminar su Cuenta de acuerdo con la Sección 9 y/o informarle a las autoridades competentes.',
          termsOwnershipInventionContent30: '‍13. Retroalimentación; Nombre.',
          termsOwnershipInventionContent31:
            'Si proporciona a Next Level Technology, US cualquier retroalimentación o sugerencias sobre la Plataforma o Servicios (',
          termsOwnershipInventionContent32: '"Retroalimentación")',
          termsOwnershipInventionContent33:
            '), entonces le concede a Next Level Technology, US una licencia perpetua, irrevocable, no exclusiva, transferable, sublicensable, mundial para usar tal Retroalimentación de cualquier manera que considere apropiada. Next Level Technology, US lo tratará como no confidencial y no propietario. A menos que le proporcione a Next Level Technology, US una notificación de salida, le concede a Next Level Technology, US un derecho para usar su nombre, logotipo y capturas de pantalla de la aplicación en los materiales de marketing de Next Level Technology, US. Cualquier notificación de salida no se aplicará al uso por parte de Next Level Technology, US en conformidad con esta Sección antes de que Next Level Technology, US reciba aviso.',
          termsOwnershipInventionContent34: '14. Representaciones y Garantías.',
          termsOwnershipInventionContent35:
            'Usted representa y garantiza que tiene el derecho y autoridad total para entrar en y realizar estos Términos y que entrar en estos Términos no viola ninguna asignación, concesión, licencia, gravamen, obligación, acuerdo o entendimiento con que usted es parte. Next Level Technology, US garantiza que durante un término de suscripción aplicable Next Level Technology, US no disminuirá materialmente la funcionalidad general de la Plataforma. Por cualquier incumplimiento de esa garantía, sus únicos remedios son aquellos descritos en la Sección 9.',
          termsOwnershipInventionContent36: '15. Servicios Gratuitos.',
          termsOwnershipInventionContent37:
            'a. Next Level Technology, US puede hacer algunas partes de la Plataforma disponibles de forma gratuita (',
          termsOwnershipInventionContent38: '"Productos gratuitos")',
          termsOwnershipInventionContent39:
            '). El uso de Productos gratuitos está sujeto a los términos y condiciones de estos Términos. En caso de conflicto entre esta sección y cualquier otra parte de estos Términos, esta sección controla. Los Productos gratuitos se proporcionan a usted sin cargo como se describe en la Plataforma. Usted acepta que Next Level Technology, US, en su discreción y por cualquier razón, puede terminar su acceso a los Productos gratuitos o cualquier parte de ellos, con o sin previo aviso. Next Level Technology, US no será responsable de usted o cualquier tercero por tal terminación. Usted es responsable de exportar su contenido del usuario y cualquier App de los Productos gratuitos antes de la terminación de su acceso a los Productos gratuitos por cualquier razón, siempre que si Next Level Technology, US termina su cuenta, excepto por lo requerido por la ley, Next Level Technology, US le proporcionará una oportunidad razonable para recuperar sus Apps.',
          termsOwnershipInventionContent40:
            'NO CONTESTANDO LAS SECCIONES 14, 16 Y 18.b, LOS PRODUCTOS GRATUITOS SE PROPORCIONAN "TAL CUAL" Y SIN GARANTÍA DE NINGÚN TIPO, Y NEXT LEVEL Technology, US NO TIENE OBLIGACIONES DE INDEMNIZACIÓN NI RESPONSABILIDAD DE CUALQUIER TIPO CON RESPECTO A LOS PRODUCTOS GRATUITOS A MENOS QUE LA EXCLUSIÓN DE RESPONSABILIDAD NO SEA ENFORZABLE BAJO LA LEY APLICABLE EN LA QUE NEXT LEVEL Technology, US\' RESPONSABILIDAD CON RESPECTO A LOS PRODUCTOS GRATUITOS NO EXCEDERÁ US$100. SIN EMBARGO, NEXT LEVEL Technology, US Y SUS PROVEEDORES NO REPRESENTAN NI GARANTIZAN QUE: (I) SU USO DE LOS PRODUCTOS GRATUITOS SATISFARÁ SUS REQUISITOS, (II) SU USO DE LOS PRODUCTOS GRATUITOS SERÁ ININTERRUMPIDO, TIEMPO, SEGURO O LIBRE DE ERROR, Y (III) CUALQUIER DATO PROPORCIONADO A TRAVÉS DE LOS PRODUCTOS GRATUITOS SERÁ PRECISO. NO CONTESTANDO LO ANTERIOR EN LA SECCIÓN 17, USTED ES COMPLETAMENTE RESPONSABLE BAJO ESTOS TÉRMINOS PARA NEXT LEVEL Technology, US POR CUALQUIER DAÑO QUE SURJA DE SU USO DE LOS PRODUCTOS GRATUITOS, CUALQUIER INCUMBRIMIENTO POR SU INCUMBRIMIENTO DE ESTOS TÉRMINOS Y CUALQUIER DE SU OBLIGACIÓN DE INDEMNIZACIÓN AQUÍ.',
          termsOwnershipInventionContent41: '16. Disclaimers.',
          termsOwnershipInventionContent42:
            'EXCEPTO CUANDO SE EXPRESA EXPRESAMENTE EN ESTOS TÉRMINOS, NINGÚN PARTE HACE NINGUNA GARANTÍA DE NINGÚN TIPO, YA SEA EXPRESADA, IMPLÍCITA, ESTADUTORIA O DE OTRO MODO, Y CADA PARTE ESPECÍFICAMENTE DESCARTA TODAS LAS GARANTÍAS IMPLÍCITAS, INCLUYENDO CUALQUIER GARANTÍA DE COMERCIALIDAD, APTITUD PARA UN PROPÓSITO PARTICULAR O INFRACCIÓN DE LOS TÉRMINOS PERMITIDOS POR LA LEY APLICABLE.',
          termsOwnershipInventionContent43:
            '17. Limitación de Responsabilidad.',
          termsOwnershipInventionContent44:
            'HASTA EL EXTENSO PERMITIDO POR LA LEY, EN NINGÚN EVENTO NEXT LEVEL Technology, US (O SUS PROVEEDORES) SERÁ RESPONSABLE DE USTED O CUALQUIER TERCERO POR CUALQUIER PÉRDIDA DE BENEFICIOS, PÉRDIDA DE DATOS, COSTOS DE ADQUISICIÓN DE PRODUCTOS SUSTITUTOS O CUALQUIER DAÑO INDIRECTO, CONSECUENTE, EXEMPLAR, INCIDENTAL, ESPECIAL O PUNITIVO QUE SURJA DE O SE RELACIONE CON ESTOS TÉRMINOS O SU USO DE, O INCAPACIDAD PARA USAR, LA PLATAFORMA O SERVICIOS, INCLUSO SI NEXT LEVEL Technology, US HABÍA SIDO ADVERTIDO DE LA POSIBILIDAD DE ESE DAÑO. EL ACCESO A, Y USO DE, LA PLATAFORMA Y SERVICIOS ES A SU PROPIA DISCRECIÓN Y RIESGO, Y USTED SERÁ RESPONSABLE COMPLETAMENTE POR CUALQUIER DAÑO A SU DISPOSITIVO O SISTEMA INFORMÁTICO, O PÉRDIDA DE DATOS RESULTANTE DE ELLA.',
          termsOwnershipInventionContent45:
            "HASTA EL EXTENSO PERMITIDO POR LA LEY, NO CONTESTANDO LO ANTERIOR, NEXT LEVEL TECHNOLOGY, US' RESPONSABILIDAD CONTRA USTED POR CUALQUIER DAÑO QUE SURJA DE O SE RELACIONE CON ESTOS TÉRMINOS (PARA CUALQUIER CAUSA QUE SEA Y REGARDLESS OF THE FORM OF THE ACTION), NO EXCEDERÁ EL MAYOR DE (I) LOS CARGOS QUE USTED HAYA PAGADO NEXT LEVEL TECHNOLOGY, US EN LOS 12 MESES ANTERIORES A LA EVENTO QUE DA RISE TO LIABILITY Y (II) US$50. LA EXISTENCIA DE MÁS DE UNA RECLAMACIÓN NO INCREMENTARÁ ESTE LÍMITE. USTED ACEPTA QUE NUESTROS PROVEEDORES NO TENDRÁN RESPONSABILIDAD DE NINGÚN TIPO QUE SURJA DE O SE RELACIONE CON ESTOS TÉRMINOS.",
          termsOwnershipInventionContent46: '18. Indemnification.',
          termsOwnershipInventionContent47: 'Por Usted.',
          termsOwnershipInventionContent48:
            'HASTA EL EXTENSO PERMITIDO POR LA LEY, USTED INDEMNIZARÁ NEXT LEVEL Technology, US DE Y EN CONTRA DE CUALQUIER Y TODAS LAS RESPONSABILIDADES, ACCIONES, PERDIDAS, DAÑOS Y JUDICIOS, COSTOS Y GASTOS (INCLUYENDO LOS GASTOS DE CONSEJERO EXTERNO RAZOABLE Y GASTOS) EN CONEXIÓN CON (I) SU USO DE LA PLATAFORMA O SERVICIOS EN UN MODO NO AUTORIZADO BAJO ESTOS TÉRMINOS, (II) CUALQUIER INCUMBRIMIENTO DE ESTOS TÉRMINOS POR USTED, Y (III) SU USO DE INVENCCIONES ANTERIORES O MÓDULOS REUTILIZABLES EN UN MODO NO AUTORIZADO BAJO ESTOS TÉRMINOS.',
          termsOwnershipInventionContent49:
            'POR NEXT LEVEL Technology, US. A MENOS QUE ESTÉ USANDO UN PRODUCTO GRATUITO, NEXT LEVEL Technology, US INDEMNIZARÁ Y DEFENDERÁ USTED CONTRA CUALQUIER RECLAMO, DEMANDA, ACCIÓN O PROCEDIMIENTO QUE SE HAGA O SE TRAIGA EN CONTRA DE USTED POR UN TERCERO QUE ALLEGUE QUE LA PLATAFORMA O CUALQUIER INVENCCIÓN ANTERIOR INFRINGE O MISAPROPIA CUALQUIER DERECHO DE PROPIEDAD INTELECTUAL DEL TERCERO (UNA "RECLAMACIÓN DE IP"), PROPORCIONANDO QUE USTED (I) NOTIFIQUE INMEDIATAMENTE A NEXT LEVEL Technology, US POR ESCRITO LA RECLAMACIÓN DE IP, (II) DÉ A NEXT LEVEL Technology, US CONTROL EXCLUSIVO PARA LA DEFENSA Y RESOLUCIÓN DE LA RECLAMACIÓN DE IP, Y (III) DÉ A NEXT LEVEL Technology, US TODA LA ASISTENCIA RAZONABLE, EN EL COSTO DE NEXT LEVEL Technology, US. LAS OBLIGACIONES ANTERIORES NO SE APLICAN SI (1) LA ALLEGACIÓN NO ESTÁ ESTABLECIDO CON ESPECIFICIDAD QUE LA PLATAFORMA O CUALQUIER INVENCCIÓN ANTERIOR SON LA BASE DE LA RECLAMACIÓN DE IP; (2) UNA RECLAMACIÓN DE IP SURGE DE USAR O COMBINAR LA PLATAFORMA O INVENCCIÓN ANTERIOR (OTRO QUE COMO INCORPORADO EN UNA INVENCCIÓN) CON SOFTWARE, HARDWARE, DATOS O PROCESOS NO PROPORCIONADOS POR NEXT LEVEL Technology, US, SI LA PLATAFORMA, INVENCCIÓN ANTERIOR O USO DE ELLA NO INFRINGIRÍA SIN ESE COMBINACIÓN; (3) UNA RECLAMACIÓN DE IP SURGE DE SERVICIOS PARA LOS QUE NO HAY CARGO; O (4) UNA RECLAMACIÓN DE IP SURGE DE CONTENIDO DEL USUARIO O SU INCUMBRIMIENTO DE ESTOS TÉRMINOS. SI NEXT LEVEL Technology, US CREE QUE UNA INFRACCIÓN O MISAPROPIACIÓN DE RECLAMACIÓN RELACIONADA CON LA PLATAFORMA O INVENCCIÓN ANTERIOR ES PROBABLE, ENTONCES NEXT LEVEL Technology, US PUEDE: (A) MODIFICAR LA PLATAFORMA O INVENCCIÓN ANTERIOR PARA SER NO INFRINGENTE, (B) OBTENER UNA LICENCIA PARA SU USO CONTINUO DE LA PLATAFORMA O INVENCCIÓN ANTERIOR, O (C) TERMINAR SU SUSCRIPCIÓN PARA LA PLATAFORMA EN UN AVISO POR 30 DÍAS POR ESCRITO Y DEVOLVERTE CUALQUIER PAGO POR ADELANTADO CUBRIENDO EL TÉRMINO REMANENTE DEL TÉRMINO TERMINADO.',
          termsOwnershipInventionContent50: '19. Confidencialidad.',
          termsOwnershipInventionContent51:
            'a. Definición. "Información Confidencial"',
          termsOwnershipInventionContent52:
            'significa toda información revelada por una parte (',
          termsOwnershipInventionContent53: '"Parte Reveladora")',
          termsOwnershipInventionContent54: 'a la otra parte (',
          termsOwnershipInventionContent55: '"Receptor de Información")',
          termsOwnershipInventionContent56:
            '), ya sea oral o por escrito, que está designada como confidencial o que razonablemente debería entenderse como confidencial dado la naturaleza de la información y las circunstancias de la divulgación. La Información Confidencial de NEXT LEVEL Technology, US incluye la Plataforma y cualquier Invencción anterior, y los términos y condiciones de todos los formularios de pedido (incluyendo precios). La Información Confidencial de cada parte incluye planes de negocio y marketing, tecnología y información técnica, planes de producto y diseño, y procesos de negocio revelados por dicha parte. Sin embargo, la Información Confidencial no incluye ninguna información que (i) es o se convierte en conocida públicamente sin incumplimiento de cualquier obligación que le deba a la Parte Reveladora, (ii) se sabía del Receptor de Información antes de su revelación por la Parte Reveladora sin incumplimiento de cualquier obligación que le deba a la Parte Reveladora, (iii) se recibe de una tercera parte sin incumplimiento de cualquier obligación que le deba a la Parte Reveladora, o (iv) se desarrolló independientemente por el Receptor de Información.',
          termsOwnershipInventionContent57: 'b. No Uso y No Revelación.',
          termsOwnershipInventionContent58:
            'Entre las partes, cada parte retiene todos los derechos de propiedad intelectual en y por su Información Confidencial. El Receptor de Información usará el mismo grado de cuidado que use para proteger la confidencialidad de su propia información confidencial de la misma clase (pero no menos que el cuidado razonable) para (i) no usar ninguna Información Confidencial de la Parte Reveladora para cualquier propósito fuera del alcance de estos Términos y (ii) excepto como se autorice por la Parte Reveladora por escrito, limitar el acceso a la Información Confidencial de la Parte Reveladora a aquellos de sus empleados y contratistas que necesiten ese acceso para propósitos consistentes con estos Términos y que hayan firmado acuerdos de confidencialidad con el Receptor de Información que contengan protecciones no materialmente menos protectoras de la Información Confidencial que las de estos Términos. Ninguna parte revelará los términos de estos Términos o cualquier formulario de pedido a cualquier tercero distinto de sus afiliados, asesoría legal y contadores sin el consentimiento previo por escrito de la otra parte.',
          termsOwnershipInventionContent59: 'c. Revelación Forzada.',
          termsOwnershipInventionContent60:
            'El Receptor de Información puede revelar Información Confidencial de la Parte Reveladora si se le obliga por la ley a hacerlo, siempre que el Receptor de Información le notifique previamente la revelación obligatoria (hasta el grado legalmente permitido) y proporcione asistencia razonable, en el costo de la Parte Reveladora, si la Parte Reveladora desea desafiar la revelación. Si el Receptor de Información se le obliga por la ley a revelar la Información Confidencial de la Parte Reveladora como parte de un procedimiento civil en el que la Parte Reveladora es parte y la Parte Reveladora no se opone a la revelación, la Parte Reveladora reembolsará al Receptor de Información por su costo razonable de compilar y proporcionar acceso seguro a esa Información Confidencial.',
          termsOwnershipInventionContent61: '20. Comunicaciones Electrónicas.',
          termsOwnershipInventionContent62:
            'Al usar la Plataforma, acepta recibir comunicaciones electrónicas de Next Level Technology, US (ya sea publicando avisos en la Plataforma o a través de correo electrónico). Usted acepta que cualquier aviso que Next Level Technology, US deba proporcionarle puede proporcionarse electrónicamente.',
          termsOwnershipInventionContent63: '21. Exportación.',
          termsOwnershipInventionContent64:
            'La Plataforma y cualquier Invencción, Invencción anterior y Módulo reutilizable pueden estar sujetos a leyes de control de exportación estadounidenses y pueden estar sujetos a regulaciones de exportación o importación en otros países. Usted acepta no exportar, reexportar o transferir, directamente o indirectamente, ningún dato técnico estadounidense adquirido de Next Level Technology, US, o cualquier producto que utilice dicho dato, en violación de las leyes de exportación estadounidenses o regulaciones.',
          termsOwnershipInventionContent65: '22. Arbitraje.',
          termsOwnershipInventionContent66:
            'a. Nosotros ambos estamos de acuerdo en arbitrar.',
          termsOwnershipInventionContent67:
            'Usted y Next Level Technology, US están de acuerdo en resolver cualquier reclamo relacionado con estos Términos, la Plataforma o cualquier Servicio a través de un arbitraje final y vinculante por un solo árbitro, excepto como se establece bajo la Sección 22.e. Esto incluye disputas surgiendo de, o relacionadas con la interpretación o aplicación de esta "Sección de Arbitraje", incluyendo su ejecutabilidad, revocabilidad o validez.',
          termsOwnershipInventionContent68: 'b. Resolución Informal.',
          termsOwnershipInventionContent69:
            'Antes de presentar una reclamación, cada parte está de acuerdo en intentar resolver la disputa contactando con la otra parte. Si una disputa no se resuelve dentro de treinta días de la notificación, cualquiera de las partes puede presentar una actuación formal.',
          termsOwnershipInventionContent70: 'c. Ubicación de Arbitraje.',
          termsOwnershipInventionContent71: 'La',
          termsOwnershipInventionContent72: 'American Arbitration Association',
          termsOwnershipInventionContent73:
            '(AAA) administrará la arbitración bajo sus Reglas de Arbitraje Comercial. La arbitración se celebrará en San Francisco (CA), o cualquier otro lugar que ambas partes estén de acuerdo en escribir.',
          termsOwnershipInventionContent74: ' ‍d. Excepción a la Arbitración.',
          termsOwnershipInventionContent75:
            'Cualquiera de las partes puede presentar una demanda en los tribunales federales o estatales de Alameda County, Carolina del Norte, solo para obtener una orden de restricción para detener el uso no autorizado o abuso de la Plataforma o la infracción de derechos de propiedad intelectual sin antes involucrarse en el proceso de notificación informal de disputa descrito anteriormente. Tanto usted como Next Level Technology, US consenten al lugar y jurisdicción personal.',
          termsOwnershipInventionContent76: 'e. NO ACCIONES DE CLASE.',
          termsOwnershipInventionContent77:
            'Solo puede resolver disputas con Next Level Technology, US en una base individual y no puede presentar una reclamación en una clase, consolidada o de acción representativa. Las acciones de arbitraje de clase, acciones de clase, acciones de abogado general privado y consolidación con otros arbitrajes no están permitidas.',
          termsOwnershipInventionContent78: '23. Diversos.',
          termsOwnershipInventionContent79:
            'No falla o retraso por parte de cualquiera de las partes en ejercer cualquier derecho bajo estos Términos constituirá una renuncia de ese derecho. Si cualquier término o disposición de estos Términos se determina como ilegal o inválido, tal ilegalidad o inválid se no afectará la validez del resto de estos Términos. Estos Términos se rigen por la ley de Carolina del Norte. Estos Términos, que incluyen cualquier formulario de pedido, son el acuerdo completo entre las partes con respecto al asunto aquí.',
          termsOwnershipInventionContent80: 'Bienvenido',
          termsOwnershipInventionContent81: 'Crear una nueva cuenta',
          termsOwnershipInventionContent82:
            'Al registrarse, acepta los Términos de Next Level Technology',
          termsOwnershipInventionContent83: 'Términos y condiciones',
          termsOwnershipInventionContent84: '¿Ya tiene una cuenta?',
          termsOwnershipInventionContent85: 'Inicie sesión ahora',
          termsOwnershipInventionContent86: 'Regístrese',
          Productdetails: {
            dashboard: 'Panel',
            products: 'Productos',
            addImage: 'Agregar imagen',
            name: 'Nombre',
            pointCost: 'Costo en puntos',
            availableStock: 'Stock disponible',
            description: 'Descripción',
            category: 'Categoría',
            enabled: 'Habilitado',
            isGift: '¿Es regalo?',
            save: 'Guardar',
            productAdded: 'Producto agregado',
            remove: 'Eliminar',
            showPrevious: 'Mostrar 10 resultados anteriores',
            showNext: 'Mostrar 10 resultados siguientes',
            noReviews: 'No se encontraron reseñas',
            productReviews: 'Reseñas del producto',
            user: 'Usuario',
            score: 'Puntuación',
            date: 'Fecha',
            comment: 'Comentario',
            action: 'Acción',
            maxCharacters: 'máx {{count}} caracteres',
            charactersCount: '{{current}}/{{max}} caracteres',
            updateError: 'Error al actualizar el producto',
            imageUploadSuccess: 'Imagen subida exitosamente',
            imageUploadError: 'Error al subir la imagen',
            deleteError: 'Error al eliminar el producto',
            loadError: 'Error al cargar la información del producto',
            validationError:
              'Por favor complete todos los campos requeridos con valores válidos',
            deleteConfirm: '¿Está seguro de que desea eliminar este producto?',
            reviewDeleted: 'Reseña eliminada exitosamente',
            reviewDeleteError: 'Error al eliminar la reseña',
            addComment: 'Agregar comentario',
            addCommentTitle: 'Agregar comentario',
            addCommentDescription: 'Agregue un comentario sobre el producto',
            addCommentButton: 'Agregar comentario',
            addCommentSuccess: 'Comentario agregado',
          },
          products: {
            dashboard: 'Panel',
            products: 'Productos',
            addProduct: 'Agregar producto',
            name: 'Nombre',
            pointCost: 'Puntos de costo',
            availableStock: 'Stock disponible',
            description: 'Descripción',
            addProductImage: 'Agregar imagen del producto',
            enabled: 'Habilitado',
            isGift: 'Es un regalo?',
            save: 'Guardar',
            loading: 'Cargando',
            noData: 'No se encontraron datos',
            showPrevious: 'Mostrar 10 resultados anteriores',
            showNext: 'Mostrar 10 resultados siguientes',
            product: 'Producto',
            status: 'Estado',
            cost: 'Costo',
            purchased: 'Comprado',
            available: 'Disponible',
            action: 'Acción',
            remove: 'Eliminar',
            inputError: 'Por favor, ingrese todos los valores',
            nameError:
              'El campo de nombre solo puede contener letras. Por favor, inténtelo de nuevo',
            productAdded: 'Producto agregado exitosamente',
            productDeleted: 'Producto eliminado exitosamente',
          },
          marketing: {
            dashboard: 'Panel',
            marketing: 'Marketing',
            notificationSettings: 'Configuración de notificación',
            sendUsing: 'Enviar usando',
            notification: 'Notificación',
            newProducts: 'Nuevos productos',
            productDiscount: 'Descuento de producto',
            pointsAdded: 'Puntos agregados',
            redeemRequestApproved: 'Solicitud de reembolso aprobada',
            useRewardPoints: 'Usar puntos de recompensa',
            birthday: 'Cumpleaños',
            referral: 'Referencia',
            enterNotificationTitle: 'Ingrese el título de la notificación',
            notificationTitle: 'Título de la Notificación',
            notificationTitleEnglish: 'Título de la Notificación (Inglés)',
            notificationTitleSpanish: 'Título de la Notificación (Español)',
            notificationBody: 'Cuerpo de la Notificación',
            notificationBodyEnglish: 'Cuerpo de la Notificación (Inglés)',
            notificationBodySpanish: 'Cuerpo de la Notificación (Español)',
            sendCustomNotification: 'Enviar notificación personalizada',
            selectUsers: 'Seleccionar usuarios',
            sendNotification: 'Enviar notificación',
            addNotification: 'Agregar una notificación',
            notificationSent: 'Notificación enviada exitosamente',
            deleteItem: 'Eliminar este elemento',
          },
          pointsSetup: {
            dashboard: 'Panel',
            loyaltyProgramSetup: 'Configuración del programa de lealtad',
            awardsForLevel: 'PREMIOS PARA ESTE NIVEL',
            awardsForLevelEs: 'PREMIOS PARA ESTE NIVEL',
            discount: 'Descuento',
            discountEs: 'Descuento',
            gift: 'Regalo',
            giftEs: 'Regalo',
            noGift: 'Sin regalo',
            noGiftEs: 'Sin regalo',
            selectGift: 'Seleccionar regalo',
            selectGiftEs: 'Seleccionar regalo',
            changeGift: 'Cambiar regalo',
            changeGiftEs: 'Cambiar regalo',
            awardsManagement: 'Gestión de premios',
            awardsManagementEs: 'Gestión de premios',
            addReward: 'AGREGAR PREMIO',
            addRewardTitle: 'Agregar premio',
            addRewardTitleEs: 'Agregar premio',
            awardType: 'Tipo de premio',
            awardTypeEnglish: 'Tipo de Premio (Inglés)',
            awardTypeSpanish: 'Tipo de Premio (Español)',
            awardTypeEs: 'Tipo de premio',
            points: 'Puntos',
            pointsEs: 'Puntos',
            level: 'Nivel',
            levelEs: 'Nivel',
            selectLevel: 'SELECCIONAR NIVEL',
            selectLevelEs: 'SELECCIONAR NIVEL',
            enabled: 'Habilitado',
            enabledEs: 'Habilitado',
            save: 'Guardar',
            saveEs: 'Guardar',
            loading: 'Cargando ...',
            loadingEs: 'Cargando ...',
            status: 'ESTADO',
            statusEs: 'ESTADO',
            action: 'ACCION',
            actionEs: 'ACCION',
            remove: 'Eliminar',
            removeEs: 'Eliminar',
            newAwardCreated: 'Nuevo premio creado',
            newAwardCreatedEs: 'Nuevo premio creado',
            rewardsRemoved: 'Recompensas eliminadas exitosamente',
            rewardsRemovedEs: 'Recompensas eliminadas exitosamente',
            bronze: 'Bronce',
            bronzeEs: 'Bronce',
            silver: 'Plata',
            silverEs: 'Plata',
            gold: 'Oro',
            goldEs: 'Oro',
            never: 'Nunca',
            neverEs: 'Nunca',
            pointsExpire: 'Puntos expiran',
            pointsExpireEs: 'Puntos expiran',
            addMore: 'Agregar más',
            addMoreEs: 'Agregar más',
            amount: 'MONTO',
            amountEs: 'MONTO',
            extraBonus: 'Bono extra basado en dinero gastado',
            extraBonusEs: 'Bono extra basado en dinero gastado',
            eligibilityPoints: 'Puntos de elegibilidad',
            eligibilityPointsEs: 'Puntos de elegibilidad',
            giftInactive: 'Regalo inactivo',
            giftInactiveEs: 'Regalo inactivo',
            itemName: 'Nombre del artículo',
            itemNameEs: 'Nombre del artículo',
            change: 'Cambiar',
            changeEs: 'Cambiar',
            selectLevel: 'SELECCIONAR NIVEL',
            selectLevelEs: 'SELECCIONAR NIVEL',
            levelDisplay: 'Mostrar nivel',
            levelDisplayEs: 'Mostrar nivel',
            awardTypeLabel: 'Tipo de premio',
            awardTypeLabelEs: 'Tipo de premio',
            discountLabel: 'Descuento',
            discountLabelEs: 'Descuento',
            pointsLabel: 'Puntos',
            pointsLabelEs: 'Puntos',
            levelLabel: 'Nivel',
            levelLabelEs: 'Nivel',
            enabledLabel: 'Habilitado',
            enabledLabelEs: 'Habilitado',
            removeBonus: 'Eliminar bono',
            removeBonusEs: 'Eliminar bono',
            helpText: 'Texto de ayuda aquí',
            helpTextEs: 'Texto de ayuda aquí',
            bronzeLevel: 'Nivel de bronce',
            bronzeLevelEs: 'Nivel de bronce',
            silverLevel: 'Nivel de plata',
            silverLevelEs: 'Nivel de plata',
            goldLevel: 'Nivel de oro',
            goldLevelEs: 'Nivel de oro',
          },
          storeSetup: {
            dashboard: 'Panel',
            dashboardEs: 'Panel',
            loyaltyProgramStoreSetup:
              'Configuración del programa de lealtad y tienda',
            loyaltyProgramStoreSetupEs:
              'Configuración del programa de lealtad y tienda',
            storeName: 'Nombre de la tienda',
            storeNameEs: 'Nombre de la tienda',
            storeQRCode: 'Código QR de la tienda',
            storeQRCodeEs: 'Código QR de la tienda',
            storeLogo: 'Logo de la tienda',
            storeLogoEs: 'Logo de la tienda',
            generate: 'Generar',
            generateEs: 'Generar',
            downloadImage: 'Descargar imagen',
            downloadImageEs: 'Descargar imagen',
            uploadLogo: 'Subir logo',
            uploadLogoEs: 'Subir logo',
            storeUpdated: 'Tienda actualizada exitosamente',
            storeUpdatedEs: 'Tienda actualizada exitosamente',
            imageSizeError: 'El tamaño de la imagen debe ser menor a 5 MB',
            imageSizeErrorEs: 'El tamaño de la imagen debe ser menor a 5 MB',
            updateError: 'Error al actualizar la tienda',
            maxLengthExceeded:
              'Se excedió la longitud máxima de {{maxLength}} caracteres',
            characters: 'caracteres',
            charactersEs: 'caracteres',
            invalidFileType: 'Only JPG, PNG and SVG images are allowed',
            invalidFileTypeEs: 'Solo se permiten imágenes JPG, PNG y SVG',
            downloadError: 'Error downloading QR code',
            downloadErrorEs: 'Error al descargar el código QR',
            processingFile: 'Procesando archivo...',
            updatingStore: 'Actualizando tienda...',
            processing: 'Procesando...',
            saving: 'Guardando...',
            uploadLogoDescription:
              'Sube una imagen de logo de tienda (JPG, PNG, o SVG)',
          },

          shopUsers: {
            dashboard: 'Dashboard',
            dashboardEs: 'Panel',
            users: 'Users',
            usersEs: 'Usuarios',
            user: 'User',
            userEs: 'Usuario',
            pending: 'Pending',
            pendingEs: 'Pendiente',
            purchases: 'Purchases',
            purchasesEs: 'Compras',
            level: 'Level',
            levelEs: 'Nivel',
            points: 'Points',
            pointsEs: 'Puntos',
            spent: '$ Spent',
            spentEs: '$ Gastado',
            activeStatus: 'Active Status',
            activeStatusEs: 'Estado Activo',
            noData: 'No data found',
            noDataEs: 'No se encontraron datos',
            showPrevious: 'Show previous 10 results',
            showPreviousEs: 'Mostrar 10 resultados anteriores',
            showNext: 'Show next 10 results',
            showNextEs: 'Mostrar siguientes 10 resultados',
          },
          spanish: 'Español',
          english: 'English',

          notifications: {
            product: {
              updated: 'Producto actualizado exitosamente',
              enabled: 'Producto habilitado exitosamente',
              disabled: 'Producto deshabilitado exitosamente',
              removed: 'Producto eliminado exitosamente',
            },
            purchase: {
              updated: 'Compra actualizada exitosamente',
              accepted: 'Compra aceptada exitosamente',
              rejected: 'Compra rechazada exitosamente',
              bulkAccepted: 'Compras aceptadas exitosamente',
              bulkRejected: 'Compras rechazadas exitosamente',
            },
            loyalty: {
              accepted: 'Puntos de lealtad aceptados exitosamente',
              rejected: 'Puntos de lealtad rechazados exitosamente',
            },
            bonus: {
              removed: 'Bono eliminado exitosamente',
            },
            rewards: {
              updated: 'Valor actualizado exitosamente',
              removed: 'Recompensas eliminadas exitosamente',
              accepted: 'Recompensa aceptada exitosamente',
              rejected: 'Recompensa rechazada exitosamente',
              bulkAccepted: 'Recompensas aceptadas exitosamente',
              bulkRejected: 'Recompensas rechazadas exitosamente',
            },
            gifts: {
              accepted: 'Regalo aceptado exitosamente',
              rejected: 'Regalo rechazado exitosamente',
              bulkAccepted: 'Regalos aceptados exitosamente',
              bulkRejected: 'Regalos rechazados exitosamente',
            },
          },
        },
        shopUserDetail: {
          dashboard: 'Panel',
          users: 'Usuarios',
          pending: 'PENDIENTE',
          pendingEs: 'PENDIENTE',
          purchased: 'COMPRADO',
          purchasedEs: 'COMPRADO',
          level: 'NIVEL',
          levelEs: 'NIVEL',
          points: 'PUNTOS',
          pointsEs: 'PUNTOS',
          spent: '$ GASTADO',
          spentEs: '$ GASTADO',
          referral: 'REFERIDO',
          referralEs: 'REFERIDO',
          userActivity: 'Actividad del usuario',
          userActivityEs: 'Actividad del usuario',
          referralCode: 'Código de referido',
          referralCodeEs: 'Código de referido',
          moneySpent: 'Dinero Gastado',
          moneySpentEs: 'Dinero Gastado',
          addAmount: 'Agregar Monto',
          addAmountEs: 'Agregar Monto',
          addNote: 'Agregar Nota',
          addNoteEs: 'Agregar Nota',
          save: 'Guardar',
          saveEs: 'Guardar',
          giveBonus: 'Dar Bono',
          giveBonusEs: 'Dar Bono',
          enterNumber: 'Por favor Ingresa un Número',
          enterNumberEs: 'Por favor Ingresa un Número',
          rewardPoints: 'Puntos de recompensa',
          rewardPointsEs: 'Puntos de recompensa',
          gifts: 'Regalos',
          giftsEs: 'Regalos',
          loyaltyPointsPurchases: 'Compras con puntos de lealtad',
          loyaltyPointsPurchasesEs: 'Compras con puntos de lealtad',
          addMoneySpent: 'AGREGAR DINERO GASTADO',
          addMoneySpentEs: 'AGREGAR DINERO GASTADO',
          user: 'USUARIO',
          received: 'RECIBIDO',
          details: 'DETALLES',
          status: 'ESTADO',
          accept: 'Aceptar',
          reject: 'Rechazar',
          accepted: 'Aceptado',
          rejected: 'Rechazado',
          date: 'FECHA',
          paid: 'PAGADO',
          amountSpent: 'MONTO GASTADO',
          note: 'NOTA',
          noData: 'No se encontraron datos',
          noDataEs: 'No se encontraron datos',
          showPrevious: 'Mostrar 10 resultados anteriores',
          showPreviousEs: 'Mostrar 10 resultados anteriores',
          showNext: 'Mostrar 10 resultados siguientes',
          showNextEs: 'Mostrar siguientes 10 resultados',
          insufficientPoints:
            '¡El usuario no tiene puntos suficientes para comprar este producto!',
          insufficientPointsEs:
            '¡El usuario no tiene puntos suficientes para comprar este producto!',
          showPrevious: 'Mostrar 10 resultados anteriores',
          showNext: 'Mostrar 10 resultados siguientes',
        },
        components: {
          dropdown: {
            filter: 'Filtrar',
          },
        },
      },
    },
  },
  lng: savedLanguage,
  fallbackLng: 'en-US',
  interpolation: {
    escapeValue: false,
  },
});

i18next.on('languageChanged', lng => {
  localStorage.setItem('language', lng);
});

export default i18next;
